import { useEffect, useState, useRef } from "react";


import AppConst from "../apis/appconst";
import AddDoctor from '../models/AddDoctor';
import axios from "axios";
import { toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import JsBarcode from 'jsbarcode';
import ReactDOM from 'react-dom';
import Select from 'react-select';
import Swal from "sweetalert2";
import NewBroker from '../models/NewBroker';
// at top of your file with other imports
import 'sweetalert2/dist/sweetalert2.min.css';
import { useNavigate } from "react-router-dom";


// Replace your jspdf imports with:
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import QRCode from "qrcode";

// treat "YYYY-MM-DD" from <input type="date"> as local start / end-of-day
function parseInputDateStart(yyyyMmDd) {
  if (!yyyyMmDd) return null;
  const parts = String(yyyyMmDd).split('-');
  if (parts.length !== 3) return new Date(yyyyMmDd);
  const y = Number(parts[0]), m = Number(parts[1]) - 1, d = Number(parts[2]);
  return new Date(y, m, d, 0, 0, 0); // local midnight
}
function parseInputDateEnd(yyyyMmDd) {
  if (!yyyyMmDd) return null;
  const parts = String(yyyyMmDd).split('-');
  if (parts.length !== 3) return new Date(yyyyMmDd);
  const y = Number(parts[0]), m = Number(parts[1]) - 1, d = Number(parts[2]);
  return new Date(y, m, d, 23, 59, 59, 999); // local end of day
}

function Registrations() {
  // return YYYY-MM-DD for the browser's local date (not UTC)
// return YYYY-MM-DD for the browser's local date (not UTC)
const getLocalDateYYYYMMDD = () => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};
// near other refs at top of component
const sessionLoadedRef = useRef(false);

// normalize ANY incoming date-like value to local YYYY-MM-DD
function normalizeToLocalYYYYMMDD(input) {
  if (!input && input !== 0) return getLocalDateYYYYMMDD();
  const s = String(input).trim();

  // already YYYY-MM-DD -> return as-is
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;

  // MySQL-ish "YYYY-MM-DD HH:mm:ss" or "YYYY-MM-DDTHH:mm:ss..."
  const mysqlLike = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}):?(\d{2})?)?/);
  if (mysqlLike) {
    const y = Number(mysqlLike[1]);
    const m = Number(mysqlLike[2]) - 1;
    const d = Number(mysqlLike[3]);
    // construct local Date using components so no timezone shift
    const dt = new Date(y, m, d);
    return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`;
  }

  // ISO or other string -> let Date parse then extract the local date parts
  const parsed = new Date(s);
  if (!isNaN(parsed.getTime())) {
    const yy = parsed.getFullYear();
    const mm2 = String(parsed.getMonth() + 1).padStart(2, '0');
    const dd2 = String(parsed.getDate()).padStart(2, '0');
    return `${yy}-${mm2}-${dd2}`;
  }

  // fallback to local today
  return getLocalDateYYYYMMDD();
}

const [isAdmin, setIsAdmin] = useState(false);
const [showBrokerModal, setShowBrokerModal] = useState(false);
{/* ── Test Search with pagination ── */}
const [testPage, setTestPage] = useState(0);
const TESTS_PER_PAGE = 5;
// ── NEW: phone search states (add near other useState) ──
const [searchMode, setSearchMode]           = useState('phone');
const [phoneSearch, setPhoneSearch]         = useState('');
const [patientResults, setPatientResults]   = useState([]);
const [showPatientModal, setShowPatientModal] = useState(false);
const [searchLoading, setSearchLoading]     = useState(false);


const [labSearchInput, setLabSearchInput] = useState('');
const [labSearchSuggestions, setLabSearchSuggestions] = useState([]);
const labSearchDebounceRef = useRef(null);

const [originalRecord, setOriginalRecord] = useState(null);


// helper: clears 0 on focus
// helper: clears 0 on focus (for age and amount fields)
const handleFocus = (e) => {
  const name = e.target.name;
  // If it's an age field and 0, clear it
  if (["lab_reg_age_year", "lab_reg_age_month", "lab_reg_age_day"].includes(name)) {
    if (e.target.value === "0" || e.target.value === "0.00") {
      e.target.value = "";
      const fakeEvent = { target: { name, value: "" } };
      handleChange(fakeEvent);
    }
  } 
  // If it's a payment field, same logic
  else if (["lab_dis_per", "lab_fix_deposit", "lab_paid"].includes(name)) {
    if (e.target.value === "0" || e.target.value === "0.00") {
      e.target.value = "";
    }
  }
};

// helper: restores 0 if empty on blur (for age and numeric fields)
const handleBlur = (e) => {
  const name = e.target.name;
  // If empty, restore 0 only for age and money fields
  if (["lab_reg_age_year", "lab_reg_age_month", "lab_reg_age_day", "lab_dis_per", "lab_fix_deposit", "lab_paid"].includes(name)) {
    if (e.target.value === "" || e.target.value === null) {
      e.target.value = "0";
      const fakeEvent = { target: { name, value: "0" } };
      handleChange(fakeEvent);
    }
  }
};




    const inputRef = useRef();
    const [finalprice, setFinalprice] = useState(0);
    const [isSaved, setIsSaved] = useState(false)
    const [Name, setName] = useState('');
    const [image, setImage] = useState('')
    const [ldata, setLdata] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [ageAutoZero, setAgeAutoZero] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
const [showSearchDropdown, setShowSearchDropdown] = useState(false);
// near other refs
const selectRef = useRef(null);
const [pendingReferralToResolve, setPendingReferralToResolve] = useState(null);

    const [showCollectedDropdown, setShowCollectedDropdown] = useState(false);
    
    const patientNameRef = useRef(null);
const ageYearRef = useRef(null);

const navigate = useNavigate();
       // STATE TO STORE THE ORIGINAL LAB_REG_TYPE for comparison
    const [originalLabRegType, setOriginalLabRegType] = useState("");

    // Added state to control UHID readonly or editable
    const [isUHIDReadOnly, setIsUHIDReadOnly] = useState(false);
    const referralInputRef = useRef(null);
// Broker select state
const [brokerOptions, setBrokerOptions] = useState([]);
const [brokerId, setBrokerId] = useState('');       // selected broker id (string)
const [brokerLabel, setBrokerLabel] = useState(''); // selected broker label / name
const [loadingBrokers, setLoadingBrokers] = useState(false);


const [paymentMode, setPaymentMode] = useState('Cash');
const [paymentAmount, setPaymentAmount] = useState('');
const [paymentReceivedBy, setPaymentReceivedBy] = useState('');
const [paymentRemarks, setPaymentRemarks] = useState('');
const [paymentHistory, setPaymentHistory] = useState([]);
const [showPaymentModal, setShowPaymentModal] = useState(false);


// debounce ref for type-ahead
const brokerDebounceRef = useRef(null);

    const [formData, setFormData] = useState({
        tests1: [],
        docs: [],
        users: [],
        lab_reg_id: '',
        lab_reg_uhid: '',
        lab_reg_name_title: 'Mr.',
        lab_reg_name: '',
        lab_reg_gender: 'male',
        lab_reg_address: '',
        lab_reg_type: 'Direct',
        lab_reg_age_year: '0',
        lab_reg_age_month: '0',
        lab_reg_age_day: '0',
        lab_reg_city: '',
        lab_reg_state: '',
        lab_reg_mobile: '',
        lab_reg_referral: '',
        lab_reg_sample: '',
        lab_reg_date: '',
        lab_guardian_title: '',
        lab_guardian_name: '',
        lab_collected_at: '',
        lab_total: '0',
        lab_dis_per: '0',
        lab_fix_deposit: '0',
        lab_final_amt: '0',
        lab_paid: '0',
        lab_due: '0',
        lab_pay_mode: 'Cash',
        lab_remarks: '',
        lab_reg_user: '',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });
// DEBUG & resilient docs loader (put this after your formData useState)
const [fetchError, setFetchError] = useState(null);
const [referralId, setReferralId] = useState('');
const [docSearch, setDocSearch] = useState('');
const [showReferralDropdown, setShowReferralDropdown] = useState(false);
const [filteredDoctors, setFilteredDoctors] = useState([]);

// Toggle this to true to force sample doctors (UI test)
const USE_MOCK_DOCTORS = false;

const MOCK_DOCTORS = [
  { user_id: "d1", fname: "Dr. Ameet", lname: "Shah", doc: { doc_degree: "MBBS", doc_specality: "Cardiology" } },
  { user_id: "d2", fname: "Dr. Leena", lname: "Patel", doc: { doc_degree: "MD", doc_specality: "Gynec" } },
  { user_id: "d3", fname: "Dr. Rohan", lname: "K", doc: { doc_degree: "MS", doc_specality: "Ortho" } }
];

const loadDoctorsForLab = async () => {
  try {
    setFetchError(null);

    if (USE_MOCK_DOCTORS) {
      // Allow mock for UI verification
      setFormData(prev => ({ ...prev, docs: MOCK_DOCTORS }));
      setFilteredDoctors(MOCK_DOCTORS);
      console.warn("Using MOCK_DOCTORS - backend not used");
      return;
    }

    console.log("[Lab] loadDoctorsForLab: starting fetch...");
    const fd = new FormData();
    fd.append('type', "doctor");
    fd.append('search_key', ""); // ensure server returns default list
    fd.append('page_no', "none");
    fd.append('user_cre_by', "1");

    const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      // add auth headers if your app requires them:
      // headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
    });

    console.log("[Lab] doctors response raw:", response); // <<<<<< inspect this in console
    const payload = response?.data || {};

    // Support multiple response shapes:
    const candidates = payload.records || payload.users || payload.data || payload.result || [];

    // If server returns an object with nested records, try to find it:
    let records = candidates;
    if (!Array.isArray(records)) {
      // try to find first array inside payload
      const arr = Object.values(payload).find(v => Array.isArray(v));
      records = arr || [];
    }

    // Optional: if backend uses status boolean
    if (payload.status === false) {
      console.warn("[Lab] server returned status:false", payload);
      // still attempt to use records if present
    }

    if (!Array.isArray(records)) {
      console.error("[Lab] parsed records is not an array", records);
      setFetchError("Invalid doctor list received from server");
      // fallback to empty
      setFormData(prev => ({ ...prev, docs: [] }));
      setFilteredDoctors([]);
      return;
    }

    // normalize ids & names
    const normalized = records.map(r => {
      const id = r.user_id ?? r.id ?? r._id ?? r.userId ?? "";
      const fname = String(r.fname ?? r.first_name ?? r.name ?? "").trim();
      const lname = String(r.lname ?? r.last_name ?? "").trim();
      const docObj = r.doc ?? r.doctor ?? r.profile ?? {};
      return { ...r, user_id: id, fname, lname, doc: docObj };
    });

     setFormData(prev => ({ ...prev, docs: normalized }));
    setFilteredDoctors(normalized);
    return normalized;                 // 👈 ADD
  } catch (err) {
    console.error("[Lab] loadDoctorsForLab error:", err);
    setFetchError(err.message || String(err));
    setFormData(prev => ({ ...prev, docs: [] }));
    setFilteredDoctors([]);
    return [];                         // 👈 ADD
  }
};

// run once on mount
useEffect(() => {
  loadDoctorsForLab();
}, []);


useEffect(() => {
  const stored = sessionStorage.getItem("ldata");
  if (stored) {
    const parsed = JSON.parse(stored);
    setLdata(parsed);

    if (parsed.role_id == 1) {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  }
}, []);


useEffect(() => {
  if (!pendingReferralToResolve) return;

  // prefer filteredDoctors (if you're using that) otherwise fallback to formData.docs
  const docs = (filteredDoctors && filteredDoctors.length) ? filteredDoctors : (formData.docs || []);
  if (!docs || docs.length === 0) {
    // wait until docs are loaded
    return;
  }

  const ref = String(pendingReferralToResolve).trim();
  // try matching by id first, then by full name, then by first name fallback
  let found = docs.find(d =>
    String(d.user_id ?? d.id ?? "").trim() === ref ||
    (`${(d.fname || "").trim()} ${(d.lname || "").trim()}`.trim()) === ref ||
    (d.fname || "").trim() === ref
  );

  if (found) {
    const fullName = `${(found.fname || "").trim()} ${(found.lname || "").trim()}`.trim();
    setReferralId(String(found.user_id));      // react-select expects id in referralId
    setDocSearch(fullName);                    // optional: keep the typed search in sync
    setFormData(prev => ({ ...prev, lab_reg_referral: fullName }));
  } else {
    // no doctor found — show the raw label in control but leave referralId empty
    setReferralId("");
    setDocSearch(ref);
    setFormData(prev => ({ ...prev, lab_reg_referral: ref }));
  }

  setPendingReferralToResolve(null);
}, [pendingReferralToResolve, filteredDoctors, formData.docs]);



    // Portal dropdown that positions below the target input
function PortalDropdown({ anchorRef, open, children, onSelect }) {
  const elRef = useRef(null);
  if (!elRef.current) elRef.current = document.createElement('div');

  useEffect(() => {
    const el = elRef.current;
    document.body.appendChild(el);
    return () => {
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, []);

  // compute position
  const [style, setStyle] = useState({});

  useEffect(() => {
    if (!open || !anchorRef?.current) return setStyle({ display: 'none' });

    const rect = anchorRef.current.getBoundingClientRect();
    const top = rect.bottom + window.scrollY;
    const left = rect.left + window.scrollX;
    const width = rect.width;

    setStyle({
      position: 'absolute',
      top: `${top}px`,
      left: `${left}px`,
      minWidth: `${width}px`,
      maxHeight: '220px',
      overflowY: 'auto',
      zIndex: 99999,
      boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
      background: '#fff',
      borderRadius: '4px',
      border: '1px solid rgba(0,0,0,0.08)',
      padding: '4px 0'
    });
  }, [open, anchorRef?.current, window.innerWidth, window.innerHeight]); // reposition on open

  if (!open) return null;

  return ReactDOM.createPortal(
    <div style={style} role="listbox">
      {children}
    </div>,
    elRef.current
  );
}



// Add these new state variables after your existing useState declarations:

// ✅ Helper to attach logged-in user info to any FormData
const attachUserInfo = (fd) => {
  try {
    const stored = sessionStorage.getItem("ldata");
    if (stored) {
      const u = JSON.parse(stored);
      fd.append('user_id',   u.user_id   || '');
      fd.append('user_name', `${u.fname || ''} ${u.lname || ''}`.trim());
      fd.append('user_role', u.role_id   || u.role_name || '');
    }
  } catch (e) {
    console.warn("attachUserInfo failed:", e);
  }
  return fd;
};
// Add this function to fetch payment history
const fetchPaymentHistory = async (labRegId) => {
    if (!labRegId) return;
    
    try {
        const fd = new FormData();
        fd.append('lab_reg_id', labRegId);
        
        const response = await axios.post(
            AppConst.BASE_URL + AppConst.getPaymentHistoryUrl,
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        
        if (response.data.status) {
            setPaymentHistory(response.data.records || []);
        }
    } catch (error) {
        console.error("Error fetching payment history:", error);
    }
};

// Add this function to handle payment submission
const handleAddPayment = async () => {
  // ✅ Clean the payment amount (remove commas, currency symbols)
  const cleanedAmount = String(paymentAmount).replace(/[,₹Rs\s]/g, '').trim();
  const amount = parseFloat(cleanedAmount);
  const due = parseFloat(String(formData.lab_due).replace(/[,]/g, ''));
  
  // Validation
  if (!paymentAmount || paymentAmount === '' || amount <= 0 || isNaN(amount)) {
      toast.error("Please enter a valid payment amount");
      return;
  }
  
  if (amount > due) {
      toast.error(`Payment amount (₹${amount.toFixed(2)}) cannot exceed due amount (₹${due.toFixed(2)})`);
      return;
  }
  
  if (!paymentReceivedBy.trim()) {
      toast.error("Please enter received by name");
      return;
  }
  
  try {
      const fd = new FormData();
      fd.append('lab_reg_id', formData.lab_reg_id);
      fd.append('payment_amount', amount.toString()); // ✅ Send as clean string
      fd.append('payment_mode', paymentMode);
      fd.append('payment_received_by', paymentReceivedBy);
      fd.append('payment_remarks', paymentRemarks);
      fd.append('user_id', ldata?.user_id || '1');
      
      // ✅ LOG FOR DEBUGGING
      console.log('Sending payment:', {
          lab_reg_id: formData.lab_reg_id,
          payment_amount: amount,
          payment_mode: paymentMode,
          current_due: due
      });
      
      const response = await axios.post(
          AppConst.BASE_URL + AppConst.addPaymentUrl,
          fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      
      console.log('Payment response:', response.data);
      
      if (response.data.status) {
          toast.success(response.data.success);
          
          // ✅ Clean the returned values (remove commas)
          const newPaid = parseFloat(String(response.data.new_paid).replace(/[,]/g, ''));
          const newDue = parseFloat(String(response.data.new_due).replace(/[,]/g, ''));
          
          // Update form data
          setFormData(prev => ({
              ...prev,
              lab_paid: newPaid.toFixed(2),
              lab_due: newDue.toFixed(2)
          }));
          
          // Clear payment form
          setPaymentAmount('');
          setPaymentRemarks('');
          setShowPaymentModal(false);
          
          // Refresh payment history
          fetchPaymentHistory(formData.lab_reg_id);
      } else {
          toast.error(response.data.success || 'Failed to add payment');
      }
  } catch (error) {
      console.error("Payment error:", error);
      toast.error("Failed to add payment. Please try again.");
  }
};

// Add this function to handle payment deletion
const handleDeletePayment = async (paymentId) => {
  if (!isAdmin && ldata?.role_id != 1) {
      toast.error("Only admins can delete");
      return;
  }

  const result = await Swal.fire({
      title: 'Delete Payment?',
      text: "This will reverse the payment.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete'
  });

  if (!result.isConfirmed) return;

  try {
      const fd = new FormData();
      fd.append('payment_id', paymentId);
      fd.append('user_role', 'admin');
      attachUserInfo(fd);  
      const response = await axios.post(
          AppConst.BASE_URL + AppConst.deleteLabPaymentUrl,
          fd
      );

      if (response.data.status) {
          toast.success(response.data.success);

          // ✅ Clean the returned values (remove commas if any)
          const newPaid = parseFloat(String(response.data.new_paid).replace(/[,]/g, ''));
          const newDue = parseFloat(String(response.data.new_due).replace(/[,]/g, ''));

          setFormData(prev => ({
              ...prev,
              lab_paid: newPaid.toFixed(2),
              lab_due: newDue.toFixed(2)
          }));

          fetchPaymentHistory(formData.lab_reg_id);
      } else {
          toast.error(response.data.success);
      }

  } catch (error) {
      toast.error("Delete failed");
  }
};
// Add useEffect to fetch payment history when lab_reg_id changes
useEffect(() => {
    if (formData.lab_reg_id) {
        fetchPaymentHistory(formData.lab_reg_id);
        setPaymentReceivedBy(Name); // Auto-fill with current user
    }
}, [formData.lab_reg_id]);

// REPLACE your entire handleChange function with this simpler version:

// place near other helpers inside your component
const barcodeCanvasRef = useRef(null);

const generateBarcodeDataUrl = (value, options = {}) => {
  const canvas = barcodeCanvasRef.current || document.createElement('canvas');
  const v = (value && String(value).trim()) ? String(value).trim() : 'NA';
  try {
    JsBarcode(canvas, v, {
      format: options.format || 'CODE128',
      width: options.width || 2,
      height: options.height || 60,
      displayValue: options.displayValue === undefined ? false : options.displayValue,
      margin: options.margin || 5,
      textMargin: 0
    });
    return canvas.toDataURL('image/png');
  } catch (err) {
    console.error('Barcode generation failed', err);
    return null;
  }
};

const escapeHtml = (unsafe) => {
  if (!unsafe) return '';
  return String(unsafe)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

/**
 * Print using a hidden iframe to avoid popup blocker.
 * Trigger must be a user click (e.g. onClick handler) — then the browser will allow printing.
 */
const printThermalBarcodeIframe = async (patientName, age, uhid) => {
  // 1) Generate barcode data URL
  const barcodeData = generateBarcodeDataUrl(uhid, { width: 2, height: 70, displayValue: false });

  // 2) build printable HTML
  const css = `
    <style>
      @media print {
        @page { size: 80mm auto; margin: 4mm; }
        body { -webkit-print-color-adjust: exact; -webkit-print-color-adjust: exact; }
      }
      body {
        font-family: Arial, Helvetica, sans-serif;
        margin: 0;
        padding: 6px;
        color: #000;
        width: 280px; /* ~80mm */
      }
      .ticket { text-align:center; padding:2px 4px; }
      .title { font-size:14px; font-weight:700; margin-bottom:6px; }
      .meta { font-size:12px; margin:2px 0; }
      .uhid { font-size:12px; font-weight:700; margin-top:6px; }
      .barcode { margin-top:8px; }
      img.barimg { max-width:100%; height:auto; }
      .small { font-size:10px; color:#333; margin-top:6px; }
    </style>
  `;

  const html = `<!doctype html><html><head><meta charset="utf-8"/><title>Print Barcode</title>${css}</head>
    <body>
      <div class="ticket">
        
        <div class="meta">Name: ${escapeHtml(patientName || 'N/A')}</div>
        <div class="meta">Age: ${escapeHtml(age || 'N/A')}</div>
        <div class="uhid">UHID: ${escapeHtml(uhid || 'N/A')}</div>
        <div class="barcode">${ barcodeData ? `<img class="barimg" src="${barcodeData}" alt="${escapeHtml(uhid)}"/>` : '<div style="height:60px">Barcode error</div>' }</div>
        <div class="small">Generated: ${new Date().toLocaleString()}</div>
      </div>
    </body></html>`;

  // 3) create a hidden iframe (reuse if already present)
  const existing = document.getElementById('thermal-print-iframe');
  let iframe;
  if (existing) {
    iframe = existing;
    // clear previous content
    iframe.srcdoc = 'about:blank';
  } else {
    iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.id = 'thermal-print-iframe';
    document.body.appendChild(iframe);
  }

  // Write html into the iframe and wait for it to load
  return new Promise((resolve, reject) => {
    const onLoad = () => {
      try {
        const iwin = iframe.contentWindow;
        // wait for barcode image to load inside iframe (if present)
        const imgs = iframe.contentDocument.getElementsByTagName('img');
        if (imgs.length === 0) {
          // no image to wait for — print immediately
          iwin.focus();
          iwin.print();
          // optional: remove iframe after a short timeout to avoid interfering
          setTimeout(() => { /* keep iframe for reuse; remove if you prefer */ }, 500);
          resolve(true);
        } else {
          // wait for all images to load
          let loadedCount = 0;
          const checkDone = () => {
            loadedCount++;
            if (loadedCount >= imgs.length) {
              try {
                iwin.focus();
                iwin.print();
                resolve(true);
              } catch (err) {
                reject(err);
              }
            }
          };
          for (let img of imgs) {
            if (img.complete) checkDone();
            else img.addEventListener('load', checkDone);
            img.addEventListener('error', () => {
              // still attempt to print even if image fails
              checkDone();
            });
          }
        }
      } catch (err) {
        reject(err);
      }
    };

    // Use srcdoc if supported — it avoids navigation and is immediate
    if ('srcdoc' in iframe) {
      iframe.onload = onLoad;
      iframe.srcdoc = html;
    } else {
      // fallback for older browsers: write into document
      iframe.onload = onLoad;
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();
    }

    // safety: timeout rejects if printing fails to start in N seconds
    setTimeout(() => {
      // resolve anyway rather than leaving hanging; you can choose to reject
      resolve(false);
    }, 8000);
  }).catch(err => {
    console.error('Print iframe error', err);
    return false;
  });
};

// remove duplicate imports at top if present:
// import Swal from "sweetalert2";

// remove duplicate imports: ensure only one `import Swal from "sweetalert2";` at top

const handleChange = (e) => {
  const { name, value } = e.target;

  // use functional setState to avoid race conditions
  setFormData((prev) => {
    // copy prev
    const next = { ...prev, [name]: value };

    // preserve your UHID logic
    if (name === "lab_reg_type") {
      if (value !== originalLabRegType) setIsUHIDReadOnly(false);
      else setIsUHIDReadOnly(true);
    }

    // If user is typing into Paid field, allow empty string and validate when non-empty
    if (name === "lab_paid") {
      // allow clearing the field
      if (value === "" || value === null) {
        next.lab_paid = "";
        // if final amount exists, recalc due as final - 0
        const finalAmt = parseFloat(prev.lab_final_amt || "0") || 0;
        next.lab_due = finalAmt.toFixed(2);
        return next;
      }

      // parse numeric
      const paidNum = Number(value);
      const finalNum = Number(prev.lab_final_amt || "0");

      // if not a number, ignore change (or set to empty)
      if (isNaN(paidNum)) {
        // keep previous value
        return prev;
      }

      if (paidNum > finalNum) {
        // warn and DO NOT set the invalid paid value
        Swal.fire({
          icon: "warning",
          title: "Invalid Amount",
          text: "Paid amount cannot be greater than the final amount!",
          confirmButtonColor: "#3085d6"
        });
        return prev;
      }

      // valid paid -> update paid and due
      next.lab_paid = paidNum.toString();
      next.lab_due = (finalNum - paidNum).toFixed(2);
      return next;
    }

    // If updating final amount manually (rare in your form but safe to handle)
    if (name === "lab_final_amt") {
      // allow empty
      if (value === "" || value === null) {
        next.lab_final_amt = "";
        // leave paid as-is, recalc due
        const paidNum = Number(prev.lab_paid || 0) || 0;
        next.lab_due = (0 - paidNum).toFixed(2); // likely negative — your UI may not use empty final
        return next;
      }

      const finalNum = Number(value);
      if (isNaN(finalNum)) return prev;

      // if existing paid exceeds new final -> warn and cap paid (or you can choose to block)
      const paidNum = Number(prev.lab_paid || 0) || 0;
      if (paidNum > finalNum) {
        Swal.fire({
          icon: "warning",
          title: "Paid exceeds Final",
          text: "Paid amount is greater than the new final amount — it will be adjusted to the final amount.",
          confirmButtonColor: "#3085d6"
        });
        next.lab_final_amt = finalNum.toString();
        next.lab_paid = finalNum.toFixed(2);
        next.lab_due = "0.00";
        return next;
      }

      next.lab_final_amt = finalNum.toString();
      next.lab_due = (finalNum - paidNum).toFixed(2);
      return next;
    }

    // For other fields, just return next. totals will be recalculated by useEffect below.
    return next;
  });
};



// helper to fetch tests by search key
const fetchTests = async (searchKey = "") => {
  try {
    setIsLoading(true);

    const fd = new FormData();
    fd.append("type", "test");
    fd.append("search_key", searchKey);
    fd.append("page_no", "none");
    fd.append("test_user", 1);

    const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    if (response.data && response.data.status) {
      setSearchResults(response.data.records || []);
    } else {
      setSearchResults([]);
    }
  } catch (err) {
    console.error("fetchTests error", err);
    setSearchResults([]);
  } finally {
    setIsLoading(false);
  }
};

// Validate phone number format
const validatePhoneNumber = (phone) => {
  const phoneRegex = /^[6-9]\d{9}$/; // Indian mobile number format
  return phoneRegex.test(phone);
};

// Validate UHID format (if you have specific format)
const validateUHID = (uhid) => {
  if (!uhid) return true; // UHID is optional during creation
  return uhid.length >= 8; // Minimum length check
};

// Format amount for display
const formatAmount = (amount) => {
  return parseFloat(amount || 0).toFixed(2);
};
//  const handleSubmit = async (e) => {
//     e.preventDefault();

//     const missing = [];

//     if (!referralId || String(referralId).trim() === "") {
//       missing.push("Referral Doctor (select from list)");
//     }
  
//     if (!formData.lab_reg_name || String(formData.lab_reg_name).trim() === "") {
//       missing.push("Patient Name");
//     }
  
//        // Age validation (allow 0 if ageAutoZero is true)
//      // allow 0 age — treat 0 as valid (newborn / unknown age)
// const ageYears = formData.lab_reg_age_year;
// if (ageYears === '' || ageYears === null || ageYears === undefined) {
//   missing.push("Age (Years)");
// }

//        // if ageAutoZero === true, we accept age = 0 (intentional unknown/newborn)
   
  
//     console.log("[Lab] missing fields:", missing);
  
//     if (missing.length > 0) {
//       const listHtml = missing.map(m => `<li>${m}</li>`).join("");
//       Swal.fire({
//         icon: "warning",
//         title: "Missing required fields",
//         html: `<p>Please complete the following before submitting:</p><ul style="text-align:left">${listHtml}</ul>`,
//         confirmButtonText: "OK"
//       }).then(() => {
//         // small delay to allow Swal to close and layout to stabilise
//         setTimeout(() => {
//           // focus first missing field
//           const first = missing[0];
    
//           if (first.includes("Referral")) {
//             // Focus react-select input by ID (we set inputId="referralSelectInput")
//             const sel = document.getElementById('referralSelectInput');
//             if (sel) {
//               // scroll into view (center) then focus
//               sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
//               sel.focus({ preventScroll: true });
//               return;
//             }
//             // fallback: try to focus by any Select wrapper input
//             const selFallback = document.querySelector('input[id^="react-select"]');
//             if (selFallback) {
//               selFallback.scrollIntoView({ behavior: 'smooth', block: 'center' });
//               selFallback.focus({ preventScroll: true });
//               return;
//             }
//           } else if (first.includes("Patient Name")) {
//             if (patientNameRef?.current) {
//               patientNameRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
//               patientNameRef.current.focus({ preventScroll: true });
//               return;
//             }
//             // fallback selector
//             const el = document.querySelector('input[name="lab_reg_name"]');
//             if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.focus({ preventScroll: true }); return; }
//           } else if (first.includes("Age")) {
//             if (ageYearRef?.current) {
//               ageYearRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
//               ageYearRef.current.focus({ preventScroll: true });
//               return;
//             }
//             const el = document.querySelector('input[name="lab_reg_age_year"]');
//             if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.focus({ preventScroll: true }); return; }
//           }
    
//           // Final fallback: scroll to top of form
//           const formEl = document.querySelector('form');
//           if (formEl) formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    
//         }, 150); // 150ms is usually enough; bump to 300ms if needed
//       });
//       return; // stop submission
//     }
    

//     const fd = new FormData();

//     // Create a new array for lab_items that includes the 'lab_item_total' property
//     const itemsWithTotal = formData.tests1.map(item => ({
//         ...item,
//         lab_item_total: item.test_price // Add the missing property here
//     }));

//     // Append all other form data
//     fd.append('lab_reg_id', formData.lab_reg_id);
//     fd.append('lab_reg_name_title', formData.lab_reg_name_title);
//     fd.append('lab_reg_uhid', formData.lab_reg_uhid);
//     fd.append('lab_reg_name', formData.lab_reg_name);
//     fd.append('lab_reg_gender', formData.lab_reg_gender);
//     fd.append('lab_reg_address', formData.lab_reg_address);
//     fd.append('lab_reg_type', formData.lab_reg_type);
//     fd.append('lab_reg_age_year', formData.lab_reg_age_year);
//     fd.append('lab_reg_age_month', formData.lab_reg_age_month);
//     fd.append('lab_reg_age_day', formData.lab_reg_age_day);
//     fd.append('lab_reg_city', formData.lab_reg_city);
//     fd.append('lab_reg_state', formData.lab_reg_state);
//     fd.append('lab_reg_mobile', formData.lab_reg_mobile);
//     fd.append('lab_reg_referral', formData.lab_reg_referral);
//     fd.append('lab_reg_sample', formData.lab_reg_sample);
//     fd.append('lab_reg_date', formData.lab_reg_date);
//     fd.append('lab_guardian_title', formData.lab_guardian_title);
//     fd.append('lab_guardian_name', formData.lab_guardian_name);
//     fd.append('lab_collected_at', formData.lab_collected_at);
//     fd.append('lab_total', formData.lab_total);
//     fd.append('lab_dis_per', formData.lab_dis_per);
//     fd.append('lab_fix_deposit', formData.lab_fix_deposit);
//     fd.append('lab_final_amt', formData.lab_final_amt);
//     fd.append('lab_paid', formData.lab_paid);
//     fd.append('lab_due', formData.lab_due);
//     fd.append('lab_pay_mode', formData.lab_pay_mode);
//     fd.append('lab_remarks', formData.lab_remarks);
    
//     // **FIX**: Stringify the new array that includes the total
//     fd.append('lab_items', JSON.stringify(itemsWithTotal)); 
    
//     fd.append('lab_reg_user', ldata.user_id);
//     fd.append('broker_id', brokerId || '');
//     fd.append('broker_name', brokerLabel || '');
    
//     try {
//         const response = await axios.post(AppConst.BASE_URL + AppConst.addLabRegUrl, fd, {
//             headers: {
//                 'Content-Type': 'multipart/form-data',
//             },
//         });
//  console.log("res : " + JSON.stringify(response))

//             if (response.data.status) {
//                 setFormData(prev => ({
//                     ...prev,
//                     lab_reg_uhid: response.data.lab_reg_dt.lab_reg_uhid,
//                     lab_reg_id: response.data.lab_reg_dt.lab_reg_id,
//                     isAlert: true,
//                     alertMsg: response.data.success,
//                     alertMsgTyp: response.data.type,
//                 }));
//                 // window.location.href = "/lab_patient_list";
//                  toast.success("Registered successfully");
//                  setIsSaved(true)
//             }
//             else {
//                 setFormData(prev => ({
//                     ...prev,
//                     isAlert: true,
//                     alertMsg: response.data.success,
//                     alertMsgTyp: response.data.type,
//                 }));
//             }
//         } catch (error) {
//             setFormData(prev => ({
//                 ...prev,
//                 isAlert: true,
//                 alertMsg: "Failed",
//                 alertMsgTyp: "danger",
//             }));
//         }

//     };



// useEffect(() => {
//   const key = formData.search_key;
//   // key ko trim karke check karo, agar empty hai, par original me " " hai to search chalu karo
//   if ((key.trim().length === 0 && key.length > 0) || key.length === 0) {
//     // Agar only spaces hain (key length > 0 but trim empty) toh search mat karo
//     setSearchResults([]);
//     return;
//   }

  // Baaki search code yahan chalu kar do...
// }, [formData.search_key]);
const handleSubmit = async (e) => {
  e.preventDefault();

  // ============================================
  // STEP 1: VALIDATION
  // ============================================
  const missing = [];

  // Validate referral doctor
  if (!referralId || String(referralId).trim() === "") {
    missing.push("Referral Doctor (select from list)");
  }

  // Validate patient name
  if (!formData.lab_reg_name || String(formData.lab_reg_name).trim() === "") {
    missing.push("Patient Name");
  }

  // Validate age - allow 0 as valid (newborn/unknown age)
  const ageYears = formData.lab_reg_age_year;
  if (ageYears === '' || ageYears === null || ageYears === undefined) {
    missing.push("Age (Years)");
  }

  // Validate mobile number
  if (!formData.lab_reg_mobile || String(formData.lab_reg_mobile).trim() === "") {
    missing.push("Mobile Number");
  }

  // Validate at least one test
  if (!formData.tests1 || formData.tests1.length === 0) {
    missing.push("At least one test (select tests)");
  }

  console.log("[Lab] missing fields:", missing);

  // Show validation errors if any
  if (missing.length > 0) {
    const listHtml = missing.map(m => `<li>${m}</li>`).join("");
    Swal.fire({
      icon: "warning",
      title: "Missing Required Fields",
      html: `<p>Please complete the following before submitting:</p><ul style="text-align:left">${listHtml}</ul>`,
      confirmButtonText: "OK",
      confirmButtonColor: "#3085d6"
    }).then(() => {
      // Focus on first missing field after alert closes
      setTimeout(() => {
        const first = missing[0];
  
        if (first.includes("Referral")) {
          const sel = document.getElementById('referralSelectInput');
          if (sel) {
            sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
            sel.focus({ preventScroll: true });
            return;
          }
          const selFallback = document.querySelector('input[id^="react-select"]');
          if (selFallback) {
            selFallback.scrollIntoView({ behavior: 'smooth', block: 'center' });
            selFallback.focus({ preventScroll: true });
            return;
          }
        } else if (first.includes("Patient Name")) {
          if (patientNameRef?.current) {
            patientNameRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            patientNameRef.current.focus({ preventScroll: true });
            return;
          }
          const el = document.querySelector('input[name="lab_reg_name"]');
          if (el) { 
            el.scrollIntoView({ behavior: 'smooth', block: 'center' }); 
            el.focus({ preventScroll: true }); 
            return; 
          }
        } else if (first.includes("Age")) {
          if (ageYearRef?.current) {
            ageYearRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            ageYearRef.current.focus({ preventScroll: true });
            return;
          }
          const el = document.querySelector('input[name="lab_reg_age_year"]');
          if (el) { 
            el.scrollIntoView({ behavior: 'smooth', block: 'center' }); 
            el.focus({ preventScroll: true }); 
            return; 
          }
        } else if (first.includes("Mobile")) {
          const el = document.querySelector('input[name="lab_reg_mobile"]');
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            el.focus({ preventScroll: true });
            return;
          }
        } else if (first.includes("test")) {
          const el = document.querySelector('input[name="search_key"]');
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            el.focus({ preventScroll: true });
            return;
          }
        }
  
        // Final fallback: scroll to top of form
        const formEl = document.querySelector('form');
        if (formEl) formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  
      }, 150);
    });
    return; // Stop submission
  }

  // ============================================
  // STEP 2: PREPARE FORM DATA
  // ============================================
  
  // Create items array with proper structure
  const itemsWithTotal = formData.tests1.map(item => {
    // ✅ Always prefer lab_item_test_id over test_id
    // This guards against stale test_id values that might be lab_item_id by accident
    let realTestId = item.lab_item_test_id 
                  || item._raw?.lab_item_test_id 
                  || item.test_id 
                  || '';
    
    // ✅ Safety check: if test_id accidentally equals lab_item_id, override with lab_item_test_id
    if (item.lab_item_test_id && String(item.test_id) === String(item.lab_item_id)) {
        realTestId = String(item.lab_item_test_id);
    }

    return {
        test_id: String(realTestId),
        test_name: item.test_name || item.lab_item_test_name || '',
        test_price: parseFloat(item.test_price || item.lab_item_test_price || 0),
        test_discount: parseFloat(item.test_discount || 0),
        lab_item_total: parseFloat(item.lab_item_total || item.test_price || 0)
    };
});

  // Prepare FormData
  const fd = new FormData();

  // Lab registration basic info
  fd.append('lab_reg_id', formData.lab_reg_id || '');
  fd.append('lab_reg_name_title', formData.lab_reg_name_title || 'Mr.');
  fd.append('lab_reg_uhid', formData.lab_reg_uhid || '');
  fd.append('lab_reg_name', formData.lab_reg_name || '');
  fd.append('lab_reg_gender', formData.lab_reg_gender || 'Male');
  fd.append('lab_reg_address', formData.lab_reg_address || '');
  fd.append('lab_reg_type', formData.lab_reg_type || 'Direct');
  
  // Age fields
  fd.append('lab_reg_age_year', formData.lab_reg_age_year || '0');
  fd.append('lab_reg_age_month', formData.lab_reg_age_month || '0');
  fd.append('lab_reg_age_day', formData.lab_reg_age_day || '0');
  
  // Contact and location
  fd.append('lab_reg_city', formData.lab_reg_city || '');
  fd.append('lab_reg_state', formData.lab_reg_state || '');
  fd.append('lab_reg_mobile', formData.lab_reg_mobile || '');
  
  // Referral and sample
  fd.append('lab_reg_referral', formData.lab_reg_referral || '');
  fd.append('lab_reg_sample', formData.lab_reg_sample || '');
  fd.append('lab_reg_date', formData.lab_reg_date || '');
  
  // Guardian info
  fd.append('lab_guardian_title', formData.lab_guardian_title || '');
  fd.append('lab_guardian_name', formData.lab_guardian_name || '');
  
  // Collection info
  fd.append('lab_collected_at', formData.lab_collected_at || '');
  
  // Financial details
  fd.append('lab_total', formData.lab_total || '0');
  fd.append('lab_dis_per', formData.lab_dis_per || '0');
  fd.append('lab_fix_deposit', formData.lab_fix_deposit || '0');
  fd.append('lab_final_amt', formData.lab_final_amt || '0');
  fd.append('lab_paid', formData.lab_paid || '0');
  fd.append('lab_due', formData.lab_due || '0');
  fd.append('lab_pay_mode', formData.lab_pay_mode || 'Cash');
  
  // Remarks
  fd.append('lab_remarks', formData.lab_remarks || '');
  
  // Stringify the items array
  fd.append('lab_items', JSON.stringify(itemsWithTotal)); 
  
  // User and broker data
  fd.append('lab_reg_user', ldata?.user_id || '1');
  fd.append('broker_id', brokerId || '');
  fd.append('broker_name', brokerLabel || '');
  fd.append('ipd_id', formData.ipd_id || formData.lab_ipd_id || formData.source_id || '');
  
  // ============================================
  // STEP 3: SUBMIT TO SERVER
  // ============================================
  console.log("[Lab] Submitting tests final:", JSON.stringify(itemsWithTotal, null, 2));
console.log("[Lab] formData.tests1 source:", JSON.stringify(formData.tests1, null, 2));
  try {
      
      const response = await axios.post(
          AppConst.BASE_URL + AppConst.addLabRegUrl, 
          fd, 
          {
              headers: {
                  'Content-Type': 'multipart/form-data',
              },
              timeout: 30000, // 30 seconds timeout
          }
      );

      // Dismiss loading toast
      // toast.dismiss(loadingToast);

      // console.log("[Lab] Server response:", JSON.stringify(response.data, null, 2));

      // ============================================
      // STEP 4: HANDLE SUCCESS RESPONSE
      // ============================================
      
      if (response.data.status) {
          // Update form data with saved registration details
          setFormData(prev => ({
              ...prev,
              lab_reg_uhid: response.data.lab_reg_dt?.lab_reg_uhid || prev.lab_reg_uhid,
              lab_reg_id: response.data.lab_reg_dt?.lab_reg_id || prev.lab_reg_id,
              isAlert: true,
              alertMsg: response.data.success || "Saved successfully",
              alertMsgTyp: response.data.type || "success",
          }));
          // ✅ AUDIT LOG: If this was an EDIT (not new save), log it
if (formData.lab_reg_id && originalRecord) {
  try {
      const logFd = new FormData();
      logFd.append('record_id', formData.lab_reg_id);
      logFd.append('old_data', JSON.stringify(originalRecord));
      logFd.append('remarks', 'Lab registration updated');
      attachUserInfo(logFd);
      await axios.post(
          AppConst.BASE_URL + AppConst.logEditLabRegUrl,
          logFd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      console.log("✅ Edit logged to audit");
  } catch (logErr) {
      console.warn("⚠️ Audit log failed (non-critical):", logErr);
      // Don't show error to user - audit failure shouldn't break save
  }
}
          // Show main success message
          toast.success(response.data.success || "Registration saved successfully!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
          });
          
          // Mark as saved
          setIsSaved(true);
          
          // ============================================
          // STEP 5: HANDLE WHATSAPP NOTIFICATION STATUS
          // ============================================
          
          // ============================================
// STEP 5: HANDLE WHATSAPP NOTIFICATION STATUS
// ============================================

if (response.data.whatsapp_status) {
    
  if (response.data.whatsapp_status === 'sent') {
      // WhatsApp sent successfully
      let whatsappMessage = "✅ WhatsApp notification sent successfully";
      
      // Check if PDF was also sent
      if (response.data.pdf_sent) {
          whatsappMessage += " with PDF bill";
      }
      
      toast.success(whatsappMessage, {
          position: "top-right",
          autoClose: 6000,
          // ... styling
      });
      
  } else if (response.data.whatsapp_status === 'failed') {
      // WhatsApp failed
      toast.warning(
          `⚠️ Registration saved but WhatsApp failed: ${response.data.whatsapp_message}`,
          // ... options
      );
      
  } else if (response.data.whatsapp_status === 'error') {
      // WhatsApp error
      toast.error(
          `❌ Registration saved but WhatsApp error: ${response.data.whatsapp_message}`,
          // ... options
      );
  }
}
          
          // ============================================
          // STEP 6: POST-SAVE ACTIONS (OPTIONAL)
          // ============================================
          
          // Optional: Auto-redirect after successful save
          // setTimeout(() => {
          //     window.location.href = "/lab_patient_list";
          // }, 2000);
          
      } else {
          // ============================================
          // HANDLE FAILURE RESPONSE
          // ============================================
          
          setFormData(prev => ({
              ...prev,
              isAlert: true,
              alertMsg: response.data.success || "Failed to save",
              alertMsgTyp: response.data.type || "danger",
          }));
          
          toast.error(response.data.success || "Failed to save registration", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
          });
          
          console.error("[Lab] Save failed:", response.data);
      }
      
  } catch (error) {
      // ============================================
      // HANDLE ERRORS
      // ============================================
      
      console.error("[Lab] Submit error:", error);
      
      // Determine error message based on error type
      let errorMessage = "Failed to save registration";
      let errorDetails = "";
      
      if (error.response) {
          // Server responded with error status
          errorMessage = error.response.data?.success || 
                        error.response.data?.message || 
                        `Server error: ${error.response.status}`;
          errorDetails = JSON.stringify(error.response.data);
          
          console.error("[Lab] Server error:", error.response.status, error.response.data);
          
      } else if (error.request) {
          // Request made but no response received
          errorMessage = "No response from server. Please check your internet connection.";
          errorDetails = "Network error - no response received";
          
          console.error("[Lab] Network error - no response:", error.request);
          
      } else if (error.code === 'ECONNABORTED') {
          // Request timeout
          errorMessage = "Request timeout. The server is taking too long to respond.";
          errorDetails = "Connection timeout";
          
          console.error("[Lab] Request timeout:", error.message);
          
      } else {
          // Something else happened
          errorMessage = error.message || "An unexpected error occurred";
          errorDetails = error.toString();
          
          console.error("[Lab] Unexpected error:", error);
      }
      
      // Update form state
      setFormData(prev => ({
          ...prev,
          isAlert: true,
          alertMsg: errorMessage,
          alertMsgTyp: "danger",
      }));
      
      // Show error toast
      toast.error(errorMessage, {
          position: "top-right",
          autoClose: 7000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
      });
      
      // Log full error details
      console.error("[Lab] Full error details:", errorDetails);
      
      // Optional: Show detailed error in development mode
      if (process.env.NODE_ENV === 'development') {
          console.error("[Lab] Error stack:", error.stack);
      }
  }
};
const loadBrokers = async (search = '') => {
  try {
    setLoadingBrokers(true);
    const fd = new FormData();
    fd.append('search_key', search || '');
    fd.append('page_no', 'none');
    const res = await axios.post(AppConst.BASE_URL + AppConst.getBrokerListUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    const records = (res?.data?.records && Array.isArray(res.data.records)) ? res.data.records : [];

    // Map rows to react-select options (now with phone)
    const opts = records.map(r => {
      const name = `${(r.fname||'').trim()}${r.lname ? ' ' + (r.lname||'').trim() : ''}`.trim();
      const phone = (r.mobile || r.phone || r.broker_mobile || r.broker_phone || '').toString().trim();
      
      // Label shown in the dropdown — name + phone
      const label = name
        ? (phone ? `${name} — ${phone}` : name)
        : (phone || 'Unknown');

      return {
        value: String(r.broker_id ?? r.id ?? r.user_id ?? ''),
        label,
        name,           // ✅ store separately for custom rendering
        phone,          // ✅ store separately
        raw: r
      };
    });

    // Preserve current selection if it exists and isn't in the new results
    setBrokerOptions(prev => {
      const currentBrokerId = brokerId;
      const currentBrokerLabel = brokerLabel;
      
      if (currentBrokerId) {
        const existsInNew = opts.find(o => String(o.value) === String(currentBrokerId));
        if (!existsInNew) {
          return [
            { value: String(currentBrokerId), label: currentBrokerLabel || String(currentBrokerId), name: currentBrokerLabel || '', phone: '', raw: null },
            ...opts
          ];
        }
      }
      return opts;
    });
  } catch (err) {
    console.error('loadBrokers', err);
    setBrokerOptions([]);
  } finally {
    setLoadingBrokers(false);
  }
};

useEffect(() => {
  // Wait a tick to allow session data to load first
  const timer = setTimeout(() => {
    loadBrokers('');
  }, 200);
  return () => clearTimeout(timer);
}, []);
// Replace this useEffect:
// Fix: Ensure broker option is added when brokerId/brokerLabel are set from session
useEffect(() => {
  if (!brokerId) return;
  
  // Use functional update to ensure we're working with latest state
  setBrokerOptions(prev => {
    // Check if already exists in current options
    const found = prev.find(opt => String(opt.value) === String(brokerId));
    if (found) {
      // Update the label if it's different (in case we only had ID before)
      if (brokerLabel && found.label !== brokerLabel) {
        return prev.map(opt => 
          String(opt.value) === String(brokerId) 
            ? { ...opt, label: brokerLabel }
            : opt
        );
      }
      return prev; // no change needed
    }
    
    // Prepend the broker option
    return [
      { value: String(brokerId), label: brokerLabel || String(brokerId), raw: null },
      ...prev
    ];
  });
}, [brokerId, brokerLabel]);


    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
 const storedDataF = JSON.parse(sessionStorage.getItem("ldata") || "{}");
// console.log("session data :", storedDataF);

setName(
  [storedDataF?.fname, storedDataF?.lname].filter(Boolean).join(" ")
);



        if (storedData) {
            const parsed = JSON.parse(storedData);

            const fd1 = new FormData();
            fd1.append('profile_hosp_user', 1);
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getProfileUrl1, fd1, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

               
                if (response.data.status) {

                    var user_dt = response.data.user_dt;
                    if (user_dt != null && user_dt != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            lab_collected_at: user_dt.profile_hosp_name
                        }));
                    }
                }
            } catch (error) {

            }

            const fd2 = new FormData();
            fd2.append('type', "doctor");
            fd2.append('search_key', " ");
            fd2.append('page_no', "none");
            fd2.append('user_cre_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd2, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            docs: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };

    // --- SINGLE robust loader for sessionStorage.lab_dt ---







    // useEffect(() => {
    //     if (formData.lab_total.length > 0) {
    //         var gtotal = parseFloat(formData.lab_total);
    //         setFormData(prev => ({
    //             ...prev,
    //             lab_final_amt: gtotal + ""
    //         }));
    //         if (formData.lab_dis_per.length > 0) {
    //             var dis = parseFloat(formData.lab_dis_per);
    //             gtotal = gtotal - ((gtotal * dis) / 100);
    //             setFormData(prev => ({
    //                 ...prev,
    //                 lab_final_amt: gtotal + ""
    //             }));
    //         }

    //         if (formData.lab_fix_deposit.length > 0) {
    //             var fix_dep = parseFloat(formData.lab_fix_deposit);
    //             gtotal = gtotal - fix_dep;
    //             setFormData(prev => ({
    //                 ...prev,
    //                 lab_final_amt: gtotal + ""
    //             }));
    //         }

    //         if (formData.lab_paid.length > 0) {
    //             var paid = parseFloat(formData.lab_paid);
    //             var due = gtotal - paid;
    //             setFormData(prev => ({
    //                 ...prev,
    //                 lab_due: due + ""
    //             }));
    //         }

    //     }

    // }, [formData.lab_total, formData.lab_dis_per, formData.lab_paid, formData.lab_fix_deposit]);
    useEffect(() => {
      // Parse numbers safely (empty string allowed)
      const total = parseFloat(formData.lab_total || "0") || 0;
      const disPer = parseFloat(formData.lab_dis_per || "0") || 0;
      const fixDep = parseFloat(formData.lab_fix_deposit || "0") || 0;
      const paid = formData.lab_paid === "" ? 0 : (parseFloat(formData.lab_paid || "0") || 0);
    
      // Compute final in single step
      let computedFinal = total;
    
      // apply percent discount if present
      if (disPer > 0) {
        computedFinal = computedFinal - (computedFinal * disPer) / 100;
      }
      // apply fixed deposit
      if (fixDep > 0) {
        computedFinal = computedFinal - fixDep;
      }
    
      // ensure not negative
      if (computedFinal < 0) computedFinal = 0;
    
      // compute due (if user cleared paid input we treat paid as 0)
      let computedDue = computedFinal - paid;
      if (computedDue < 0) computedDue = 0;
    
      // Update state in one setFormData call to avoid cascading updates
      setFormData((prev) => ({
        ...prev,
        lab_final_amt: computedFinal.toFixed(2),
        lab_due: computedDue.toFixed(2),
        // do NOT overwrite lab_paid here — preserve user typed value (including empty string)
      }));
    }, [formData.lab_total, formData.lab_dis_per, formData.lab_fix_deposit, formData.lab_paid]);
    

  //         function getDoctorNameById(id) {
  // const doctor = formData.docs.find(doc => doc.user_id === String(id));
  // return doctor ? doctor.fname : "Doctor not found";
  //     }



  function getDoctorNameById(id) {
    if (id === null || id === undefined || id === "") return "Doctor not found";
    const idStr = String(id).trim();
    const doctor = (formData.docs || []).find(doc => {
      // support both user_id or id property names
      const docId = doc?.user_id ?? doc?.id ?? "";
      return String(docId).trim() === idStr;
    });
    if (!doctor) return "Doctor not found";
    // prefer full name if available
    const fullName = [doctor.fname, doctor.lname].filter(Boolean).join(" ");
    return fullName || doctor.fname || "Doctor";
  }
  
const doctorSource = (filteredDoctors && filteredDoctors.length)
  ? filteredDoctors
  : (formData.docs || []);


 // ── REPLACE searchUserNow entirely ──
const runPatientSearch = async (params) => {
  setSearchLoading(true);
  try {
      const fd = new FormData();
      Object.entries(params).forEach(([k, v]) => fd.append(k, v));
      const response = await axios.post(
          AppConst.BASE_URL + AppConst.searchUhidUrlCall, fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (!response.data.status) { toast.error('No patient found'); return; }
      const records = response.data.records || [];
      if (records.length === 0) { toast.error('No patient found'); return; }
      if (records.length === 1) {
          applyPatientToForm(records[0]);
      } else {
          setPatientResults(records);
          setShowPatientModal(true);
      }
  } catch (error) {
      console.error('Search error:', error);
      toast.error('Error searching patient');
  } finally {
      setSearchLoading(false);
  }
};

// ✅ Smart unified search — auto-detects UHID / Phone / Name
const handleLabUnifiedSearch = (val) => {
  setLabSearchInput(val);
  const trimmed = val.trim();

  if (labSearchDebounceRef.current) clearTimeout(labSearchDebounceRef.current);

  // Empty → clear suggestions
  if (trimmed.length === 0) {
    setLabSearchSuggestions([]);
    return;
  }

  // Detect input type
  const isPhone        = /^[6-9]\d{9}$/.test(trimmed);         // 10-digit mobile
  const isPartialPhone = /^\d+$/.test(trimmed);                // pure digits, not yet 10
  const isUhidLike     = /^[A-Za-z]{1,3}\d+/.test(trimmed);    // e.g. "SH00028123"

  // Phone complete → search immediately (popup if multiple)
  if (isPhone) {
    labSearchDebounceRef.current = setTimeout(() => {
      runPatientSearch({ lab_reg_mobile: trimmed });
      setLabSearchSuggestions([]);
    }, 300);
    return;
  }

  // Partial phone — wait
  if (isPartialPhone && trimmed.length < 10) {
    setLabSearchSuggestions([]);
    return;
  }

  // UHID or name → live suggestions (debounced)
  if (trimmed.length >= 3) {
    labSearchDebounceRef.current = setTimeout(async () => {
      try {
        const fd = new FormData();
        if (isUhidLike) {
          fd.append('lab_reg_uhid', trimmed);
        } else {
          fd.append('lab_reg_name', trimmed);
        }
        const response = await axios.post(
          AppConst.BASE_URL + AppConst.searchUhidUrlCall,
          fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        if (response.data.status) {
          setLabSearchSuggestions(response.data.records || []);
        } else {
          setLabSearchSuggestions([]);
        }
      } catch (err) {
        console.error('Lab search error:', err);
        setLabSearchSuggestions([]);
      }
    }, 400);
  } else {
    setLabSearchSuggestions([]);
  }
};


const applyPatientToForm = (patient) => {
  const refId   = patient.lab_reg_referral || patient.ipd_refer_doctor || '';
  const refName = getDoctorNameById(refId);
  const refForForm = (refName && refName !== 'Doctor not found') ? refName : refId;
  setFormData(prev => ({
      ...prev,
      lab_reg_name_title:  patient.lab_reg_name_title  || 'Mr.',
      lab_reg_name:        patient.lab_reg_name        || '',
      lab_reg_gender:      patient.lab_reg_gender      || 'male',
      lab_reg_address:     patient.lab_reg_address     || '',
      lab_reg_city:        patient.lab_reg_city        || '',
      lab_reg_mobile:      patient.lab_reg_mobile      || '',
      lab_reg_type:        patient.lab_reg_type        || '',
      lab_reg_age_year:    patient.lab_reg_age_year    || '',
      lab_reg_age_month:   patient.lab_reg_age_month   || '',
      lab_reg_age_day:     patient.lab_reg_age_day     || '',
      lab_reg_state:       patient.lab_reg_state       || '',
      lab_reg_uhid:        patient.lab_reg_uhid        || '',
      lab_reg_referral:    refForForm,
      lab_guardian_name:   patient.lab_guardian_name   || '',
  }));
  if (refId) setPendingReferralToResolve(refId);
  setShowPatientModal(false);
  setLabSearchInput('');           // ✅ ADD
  setLabSearchSuggestions([]);     // ✅ ADD
  toast.success('Patient details loaded');
};
// kept for backward compat (called from old Search button if needed)
const searchUserNow = () => {
  const uhid = (formData.lab_reg_uhid || '').trim();
  if (uhid.length <= 7) { toast.error('Please enter a valid UHID'); return; }
  runPatientSearch({ lab_reg_uhid: uhid });
};



     const handleAddDepart = async (newDoc) => {
  const list = await loadDoctorsForLab();   // 👈 refreshes BOTH docs + filteredDoctors

  if (!newDoc) return;

  // find the new doctor by id, else by name
  let found = null;
  if (newDoc.user_id) {
    found = (list || []).find(d => String(d.user_id) === String(newDoc.user_id));
  }
  if (!found) {
    const full = `${newDoc.fname || ''} ${newDoc.lname || ''}`.trim().toLowerCase();
    found = (list || []).find(
      d => `${d.fname || ''} ${d.lname || ''}`.trim().toLowerCase() === full
    );
  }

  if (found) {
    const fullName = `${(found.fname || '').trim()} ${(found.lname || '').trim()}`.trim();
    setReferralId(String(found.user_id));
    setDocSearch(fullName);
    setFormData(prev => ({ ...prev, lab_reg_referral: fullName }));
  }
};
    // useEffect(() => {
    //     if (formData.search_key.length > 0) {
    //         document.getElementById("poptst45").click();
    //     }
    // }, [formData.search_key]);
    const handleSelUser = (lab_reg_dt) => {
        if (lab_reg_dt != null && lab_reg_dt != undefined) {
            setFormData(prev => ({
                ...prev,
                lab_reg_id: lab_reg_dt.lab_reg_id,
                lab_reg_uhid: lab_reg_dt.lab_reg_uhid,
                lab_reg_name_title: lab_reg_dt.lab_reg_name_title,
                lab_reg_name: lab_reg_dt.lab_reg_name,
                lab_reg_gender: lab_reg_dt.lab_reg_gender,
                lab_reg_address: lab_reg_dt.lab_reg_address,
                lab_reg_type: lab_reg_dt.lab_reg_type,
                lab_reg_age_year: lab_reg_dt.lab_reg_age_year,
                lab_reg_age_month: lab_reg_dt.lab_reg_age_month,
                lab_reg_age_day: lab_reg_dt.lab_reg_age_day,
                lab_reg_city: lab_reg_dt.lab_reg_city,
                lab_reg_state: lab_reg_dt.lab_reg_state,
                lab_reg_mobile: lab_reg_dt.lab_reg_mobile,
                lab_reg_referral: lab_reg_dt.lab_reg_referral,
                lab_reg_sample: lab_reg_dt.lab_reg_sample,
                lab_reg_date: lab_reg_dt.lab_reg_date,
                lab_guardian_title: lab_reg_dt.lab_guardian_title,
                lab_guardian_name: lab_reg_dt.lab_guardian_name,
                lab_collected_at: lab_reg_dt.lab_collected_at,
               
            }));
            setBrokerId(String(lab_reg_dt.lab_reg_broker_id ?? lab_reg_dt.brokerId ?? ''));
            setBrokerLabel(String(lab_reg_dt.lab_reg_broker_name ?? lab_reg_dt.broker_name ?? lab_reg_dt.brokerName ?? ''));
        }
    }

    const handleAutoGenderChange = (e) => {
      const { name, value } = e.target;
    
      let genderValue = "Other";
      if (value === "Mr." || value === "Master" ) {
        genderValue = "Male";
      } else if (value === "Miss"|| value === "Mrs.") {
        genderValue = "Female";
      }
    
      // set the title field by name (so it matches handleChange style)
      setFormData((prev) => ({
        ...prev,
        [name]: value,           // sets lab_reg_name_title
        lab_reg_gender: genderValue
      }));
    };
    
    useEffect(() => {
      console.debug("[Registrations] Session loader starting");
    
      if (sessionLoadedRef.current) {
        console.debug("[Registrations] Already loaded session data, skipping");
        return;
      }
    
      const formattedToday = getLocalDateYYYYMMDD();
      setFormData(prev => ({ ...prev, lab_reg_date: formattedToday }));
    
      // Initialize ldata
      const storedLdata = sessionStorage.getItem("ldata");
      if (storedLdata) {
        try {
          const parsed = JSON.parse(storedLdata);
          setLdata(parsed);
          initData();
        } catch (err) {
          console.warn("[Registrations] failed parsing ldata:", err);
        }
      }
    
      // Try both lab_dt and lab_prefill keys
      const raw = sessionStorage.getItem("lab_dt") || sessionStorage.getItem("lab_prefill");
      
      if (!raw) {
        console.debug("[Registrations] No session data found - new registration mode");
        setIsUHIDReadOnly(false);
        sessionLoadedRef.current = true;
        return;
      }
    
      let tmp;
      try {
        tmp = JSON.parse(raw);
      } catch (err) {
        console.error("[Registrations] Failed to parse session data:", err);
        setIsUHIDReadOnly(false);
        sessionLoadedRef.current = true;
        return;
      }
    
      if (!tmp || typeof tmp !== "object") {
        console.warn("[Registrations] Invalid session data:", tmp);
        setIsUHIDReadOnly(false);
        sessionLoadedRef.current = true;
        return;
      }
    
      console.debug("[Registrations] Loading session data:", tmp);
    // ✅ Save original snapshot for audit log
setOriginalRecord(tmp);
      // Find tests array
      const sourceTests = Array.isArray(tmp.params)
        ? tmp.params
        : (Array.isArray(tmp.all_tests) ? tmp.all_tests : (Array.isArray(tmp.tests) ? tmp.tests : (Array.isArray(tmp.tests1) ? tmp.tests1 : [])));
    
      const transformedTests = transformTestData(sourceTests || []);
      const autoTotal = transformedTests.reduce((s, t) => s + Number(t.lab_item_total ?? t.test_price ?? 0), 0);
    
      // Update form data
      setFormData(prev => ({
        ...prev,
        tests1: transformedTests,
        lab_reg_id: tmp.lab_reg_id ?? "",
        lab_reg_uhid: tmp.lab_reg_uhid ?? prev.lab_reg_uhid,
        lab_reg_name_title: tmp.lab_reg_name_title ?? prev.lab_reg_name_title,
        lab_reg_name: tmp.lab_reg_name ?? prev.lab_reg_name,
        lab_reg_gender: tmp.lab_reg_gender ?? prev.lab_reg_gender,
        lab_reg_address: tmp.lab_reg_address ?? prev.lab_reg_address,
        lab_reg_type: tmp.lab_reg_type ?? prev.lab_reg_type,
        lab_reg_age_year: tmp.lab_reg_age_year ?? prev.lab_reg_age_year,
        lab_reg_age_month: tmp.lab_reg_age_month ?? prev.lab_reg_age_month,
        lab_reg_age_day: tmp.lab_reg_age_day ?? prev.lab_reg_age_day,
        lab_reg_city: tmp.lab_reg_city ?? prev.lab_reg_city,
        lab_reg_state: tmp.lab_reg_state ?? prev.lab_reg_state,
        lab_reg_mobile: tmp.lab_reg_mobile ?? prev.lab_reg_mobile,
        lab_reg_referral: tmp.lab_reg_referral ?? prev.lab_reg_referral,
        lab_reg_sample: tmp.lab_reg_sample ?? prev.lab_reg_sample,
        lab_reg_date: normalizeToLocalYYYYMMDD(tmp.lab_reg_date || formattedToday),
        lab_guardian_title: tmp.lab_guardian_title ?? prev.lab_guardian_title,
        lab_guardian_name: tmp.lab_guardian_name ?? prev.lab_guardian_name,
        lab_collected_at: tmp.lab_collected_at ?? prev.lab_collected_at,
        lab_total: (tmp.lab_total ?? autoTotal).toString(),
        lab_dis_per: tmp.lab_dis_per ?? prev.lab_dis_per,
        lab_fix_deposit: tmp.lab_fix_deposit ?? prev.lab_fix_deposit,
        lab_final_amt: tmp.lab_final_amt ?? prev.lab_final_amt,
        lab_paid: tmp.lab_paid ?? prev.lab_paid,
        lab_due: tmp.lab_due ?? prev.lab_due,
        lab_pay_mode: tmp.lab_pay_mode ?? prev.lab_pay_mode,
        lab_remarks: tmp.lab_remarks ?? prev.lab_remarks,
        lab_reg_user: tmp.lab_reg_user ?? prev.lab_reg_user,
      }));
    
      // Set broker
      setBrokerId(String(tmp.lab_reg_broker_id ?? tmp.brokerId ?? ''));
      setBrokerLabel(String(tmp.lab_reg_broker_name ?? tmp.broker_name ?? tmp.brokerName ?? ''));
      setTimeout(() => loadBrokers(''), 100);
    
      // Set referral (will be resolved once doctors load)
      setPendingReferralToResolve(tmp.lab_reg_referral ?? tmp.lab_reg_referral_id ?? "");
    
      // Lock UHID if this is an existing patient
      setOriginalLabRegType(tmp.lab_reg_type ?? "");
      setIsUHIDReadOnly(Boolean(tmp.lab_reg_uhid));
    
      sessionLoadedRef.current = true;
      console.debug("[Registrations] Session data loaded successfully");
    
      // Clean up session storage after loading
      return () => {
        try {
          sessionStorage.removeItem("lab_prefill");
          sessionStorage.removeItem("lab_dt");
        } catch (e) {
          console.warn("Cleanup error:", e);
        }
      };
    }, []);
        
    const transformTestData = (tests = []) => {
      return (tests || []).map(test => {
        const raw = test || {};
    
        // ✅ STRICT: Always prefer lab_item_test_id; NEVER use lab_item_id or test_id alone
        // because test_id from prior submit might be stale/wrong
        let testId = "";
        
        if (raw.lab_item_test_id !== undefined && raw.lab_item_test_id !== null && raw.lab_item_test_id !== "") {
          testId = String(raw.lab_item_test_id);
        } else if (raw._raw?.lab_item_test_id) {
          testId = String(raw._raw.lab_item_test_id);
        } else if (raw.test_id && !raw.lab_item_id) {
          // Only trust raw.test_id if there's NO lab_item_id (i.e. fresh from search)
          testId = String(raw.test_id);
        } else if (raw.test_id && String(raw.test_id) !== String(raw.lab_item_id)) {
          // raw.test_id exists AND it's different from lab_item_id — trust it
          testId = String(raw.test_id);
        }
    
        const testName = String(raw.lab_item_test_name ?? raw.test_name ?? raw.name ?? "").trim();
        const priceRaw = raw.lab_item_test_price ?? raw.test_price ?? raw.test_rate ?? raw.price ?? 0;
        const price = Number(priceRaw || 0);
        const labItemTotal = Number(raw.lab_item_total ?? raw.lab_item_test_price ?? price);
        const testDiscount = Number(raw.lab_item_dis_per ?? raw.test_discount ?? raw.test_item_discount ?? 0);
    
        return {
          test_id: testId,
          test_name: testName,
          test_price: price,
          lab_item_total: labItemTotal,
          test_discount: testDiscount,
          _raw: raw,
          lab_item_test_id: raw.lab_item_test_id,
          lab_item_test_name: raw.lab_item_test_name,
          lab_item_test_price: raw.lab_item_test_price,
          lab_item_id: raw.lab_item_id,
        };
      });
    };
    
    
    




    useEffect(() => {
      const delayDebounceFn = setTimeout(() => {
        const key = (formData.search_key ?? "").trim();
        if (key.length > 0) {
          // typed search
          fetchTests(key);
          setShowSearchDropdown(true);
        } else {
          // empty input: load default (first page / popular tests) so dropdown still shows
          fetchTests("");     // make sure your API returns a sensible default for empty search_key
          // keep dropdown open when field is focused; effect runs on value change only
        }
      }, 300);
    
      return () => clearTimeout(delayDebounceFn);
    }, [formData.search_key]);
    
    
 
 
    // const handleSelTst = (selectedTest) => {
    //   if (!selectedTest) return;
    
    //   // Normalize incoming test (selectedTest may come from search API or from server)
    //   const normalized = transformTestData([selectedTest])[0];
    
    //   // Get the ID and name from the selected test - be flexible with property names
    //   const selId = String(
    //     normalized.test_id || 
    //     normalized.lab_item_test_id || 
    //     normalized.id || 
    //     selectedTest.test_id || 
    //     selectedTest.id || 
    //     ""
    //   ).trim().toLowerCase();
      
    //   const selName = String(
    //     normalized.test_name || 
    //     normalized.lab_item_test_name || 
    //     selectedTest.test_name || 
    //     selectedTest.name || 
    //     ""
    //   ).trim().toLowerCase();
    
    //   // Check if test already exists - be more flexible with comparisons
    //   const isAlreadyAdded = formData.tests1.some(test => {
    //     // Get all possible ID variations from existing test
    //     const tId = String(
    //       test.test_id ?? 
    //       test.lab_item_test_id ?? 
    //       test.id ?? 
    //       test._raw?.test_id ?? 
    //       test._raw?.lab_item_test_id ?? 
    //       test._raw?.id ?? 
    //       ""
    //     ).trim().toLowerCase();
        
    //     // Get all possible name variations from existing test
    //     const tName = String(
    //       test.test_name ?? 
    //       test.lab_item_test_name ?? 
    //       test.name ?? 
    //       test._raw?.test_name ?? 
    //       test._raw?.lab_item_test_name ?? 
    //       test._raw?.name ?? 
    //       ""
    //     ).trim().toLowerCase();
    
    //     // Match by ID (preferred) or by name (fallback)
    //     const idMatch = (selId && tId && selId === tId);
    //     const nameMatch = (selName && tName && selName === tName);
        
    //     return idMatch || nameMatch;
    //   });
    
    //   if (isAlreadyAdded) {
    //     toast.error("Test Already Added");
    //     return;
    //   }
    
    //   const updatedTests = [...formData.tests1, normalized];
    
    //   const total = updatedTests.reduce(
    //     (sum, test) => sum + Number(test.lab_item_total ?? test.test_price ?? 0),
    //     0
    //   );
    
    //   setFormData(prev => ({
    //     ...prev,
    //     tests1: updatedTests,
    //     lab_total: total.toFixed(2)
    //   }));
      
    //   // Success feedback
    //   //toast.success(`${selName || 'Test'} added successfully`);
    // };
    
    
    const handleSelTst = async (selectedTest) => {
      if (!selectedTest) return;
    
      // Normalize incoming test (selectedTest may come from search API or from server)
      const normalized = transformTestData([selectedTest])[0];
    
      // Get the ID and name from the selected test - be flexible with property names
      const selId = String(
        normalized.test_id || 
        normalized.lab_item_test_id || 
        normalized.id || 
        selectedTest.test_id || 
        selectedTest.id || 
        ""
      ).trim().toLowerCase();
      
      const selName = String(
        normalized.test_name || 
        normalized.lab_item_test_name || 
        selectedTest.test_name || 
        selectedTest.name || 
        ""
      ).trim();
    
      // Check if test already exists - be more flexible with comparisons
      const isAlreadyAdded = formData.tests1.some(test => {
        // Get all possible ID variations from existing test
        const tId = String(
          test.test_id ?? 
          test.lab_item_test_id ?? 
          test.id ?? 
          test._raw?.test_id ?? 
          test._raw?.lab_item_test_id ?? 
          test._raw?.id ?? 
          ""
        ).trim().toLowerCase();
        
        // Get all possible name variations from existing test
        const tName = String(
          test.test_name ?? 
          test.lab_item_test_name ?? 
          test.name ?? 
          test._raw?.test_name ?? 
          test._raw?.lab_item_test_name ?? 
          test._raw?.name ?? 
          ""
        ).trim().toLowerCase();
    
        // Match by ID (preferred) or by name (fallback)
        const idMatch = (selId && tId && selId === tId);
        const nameMatch = (selName.toLowerCase() && tName && selName.toLowerCase() === tName);
        
        return idMatch || nameMatch;
      });
    
      // If test already added, show confirmation popup
      if (isAlreadyAdded) {
        const result = await Swal.fire({
          title: 'Test Already Added',
          html: `<p>The test "<strong>${selName}</strong>" is already in the list.</p><p>Do you want to add it again?</p>`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Add Again',
          cancelButtonText: 'No, Cancel'
        });
    
        // If user clicked cancel, don't add the test
        if (!result.isConfirmed) {
          return;
        }
        // If confirmed, continue to add the test (fall through to the code below)
      }
    
      // Add the test (either new test or confirmed duplicate)
      const updatedTests = [...formData.tests1, normalized];
    
      const total = updatedTests.reduce(
        (sum, test) => sum + Number(test.lab_item_total ?? test.test_price ?? 0),
        0
      );
    
      setFormData(prev => ({
        ...prev,
        tests1: updatedTests,
        lab_total: total.toFixed(2)
      }));
      
      // Success feedback (optional - you can uncomment if you want)
      // toast.success(`${selName || 'Test'} added successfully`);
    };

  const fetchConfigData = async () => {
    try {
      const res = await axios.post(
        `${AppConst.BASE_URL + AppConst.getconfig}?config_type=ipd`
      );

      if (res.data.status) {
        const data = res.data;
// console.log("Config Data:", JSON.stringify(data.header_logo));
        setImage(data.header_logo);
   
    } 
}
    catch (err) {
      console.error("Error fetching config:", err);
    }
  };

  useEffect(() => {
    fetchConfigData()
  });
 

  // Function to convert an image URL to a Base64 string
const imageUrlToBase64 = async (url) => {
  // Check if the URL is valid in the first place
  if (!url) {
    console.error("Image URL is empty or invalid.");
    return null;
  }

  try {
    const response = await fetch(url);
    if (!response.ok) {
        console.error(`Failed to fetch image. Status: ${response.status} ${response.statusText}`);
        return null;
    }
    
    const blob = await response.blob();

    // **IMPORTANT CHECK**: This ensures the downloaded file is an image.
    if (!blob.type.startsWith('image/')) {
      console.error(`The provided URL did not point to an image. It pointed to a file of type: ${blob.type}`);
      return null;
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error fetching or converting image:", error);
    return null;
  }
};

    // console.log("Search Results:", JSON.stringify(formData));
    const generatePDF = async (headerOption, includeLabCopy = true, includeRadiologyCopy = true, printLayout = 'same') => {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();   // ~210mm
      const pageHeight = doc.internal.pageSize.getHeight(); // ~297mm
      const HALF = pageHeight / 2;                          // ~148.5mm
    
      // ============================================
      // HELPER: patient details
      // ============================================
      const drawPatientDetails = (startY) => {
        autoTable(doc, {
          startY,
          body: [[
            `UHID No : ${formData.lab_reg_uhid || ''}\n` +
            `Reg No : 00${formData.lab_reg_id || ''}\n` +
            `Patient Name: ${formData.lab_reg_name_title || ''} ${formData.lab_reg_name || ''}\n` +
            `Registered Date : ${formatDate(formData.lab_reg_date)}`,
            `Address : ${formData.lab_reg_address || ''}\n` +
            `Mobile No : ${formData.lab_reg_mobile || ''}`,
            `Age : ${getAgeDisplay(formData)}\n` +
            `Gender : ${formData.lab_reg_gender || ''}\n` +
            `Referred Doctor : ${formData.lab_reg_referral || ''}`
          ]],
          theme: 'grid',
          styles: { fontSize: 7.5, cellPadding: 1.5, valign: 'top', textColor: [0,0,0], lineColor: [0,0,0], lineWidth: 0.1 },
          margin: { left: 10, right: 10 },
          tableWidth: 'auto',
          columnStyles: { 0: { cellWidth: 60 }, 1: { cellWidth: 60 }, 2: { cellWidth: 70 } }
        });
        return doc.lastAutoTable.finalY;
      };
    
      // ============================================
      // HELPER: draw one full receipt copy starting at startY
      // Returns the y position right after the copy.
      // ============================================
      const drawSingleReceipt = async (startY, copyLabel, headerImageBase64) => {
        let y = startY;
    
        // Header image (if provided)
        if (headerImageBase64) {
          doc.addImage(headerImageBase64, 0, y, pageWidth, 22);
          y += 23;
        } else {
          y += 4;
        }
    
        // Small "COPY" tag on the right
        if (copyLabel) {
          doc.setFontSize(8).setFont('helvetica', 'bold').setTextColor(120, 120, 120);
          doc.text(copyLabel, pageWidth - 12, y, { align: 'right' });
          doc.setTextColor(0, 0, 0);
        }
    
        // Patient block
        y = drawPatientDetails(y) + 1;
    
        // Tests table
        const testData = formData.tests1.map((t, i) => [
          i + 1,
          t.test_name || t.lab_item_test_name || 'N/A',
          parseFloat(t.test_price || t.lab_item_test_price || 0).toFixed(2),
          parseFloat(t.lab_item_total || t.test_price || 0).toFixed(2)
        ]);
    
        autoTable(doc, {
          startY: y,
          head: [['Sl.', 'Test Name', 'Amount', 'Final']],
          body: testData.length ? testData : [['1', 'N/A', '0.00', '0.00']],
          theme: 'grid',
          headStyles: { fillColor: [255,255,255], textColor: 0, fontStyle: 'bold', fontSize: 7.5 },
          bodyStyles: { fontSize: 7.5, textColor: 0 },
          styles: { cellPadding: 1, lineWidth: 0.1, lineColor: [0,0,0] },
          margin: { left: 10, right: 10 },
          columnStyles: {
            0: { cellWidth: 14, halign: 'center' },
            1: { cellWidth: 116 },
            2: { cellWidth: 30, halign: 'right' },
            3: { cellWidth: 30, halign: 'right' }
          }
        });
    
        y = doc.lastAutoTable.finalY + 3;
    
        // Amounts block — compact, right side
        const labelX = 140;
        const valueX = 195;
        const gap = 4;
    
        const totalAmt    = parseFloat(formData.lab_total       || 0);
        const discountPct = parseFloat(formData.lab_dis_per     || 0);
        const discountAmt = parseFloat(formData.lab_fix_deposit || 0);
        const finalAmt    = parseFloat(formData.lab_final_amt   || 0);
        const paidAmt     = parseFloat(formData.lab_paid        || 0);
        const dueAmt      = parseFloat(formData.lab_due ?? (finalAmt - paidAmt) ?? 0);
    
        doc.setFont('helvetica', 'bold').setFontSize(7.5);
        const printLine = (label, value, offset) => {
          doc.text(label, labelX, y + offset);
          doc.text(parseFloat(value || 0).toFixed(2), valueX, y + offset, null, null, 'right');
        };
        printLine('Total',     totalAmt,    0);
        printLine('Disc(%)',   discountPct, gap);
        printLine('Disc Amt',  discountAmt, gap * 2);
        printLine('Final',     finalAmt,    gap * 3);
        printLine('Paid',      paidAmt,     gap * 4);
        printLine('Due',       dueAmt,      gap * 5);
    
        const wordsY = y + gap * 5 + 4;
        doc.setFontSize(7).setFont('helvetica', 'bold');
        doc.text(`IN WORDS: ${amountInWords(formData.lab_final_amt)} only`.toUpperCase(), 10, wordsY);
    
        y = wordsY + 3;
    
        // QR + signature (compact, no payment history to keep both copies on one page)
        const qrText = `UHID: ${formData.lab_reg_uhid || 'N/A'}\nName: ${formData.lab_reg_name || 'N/A'}`;
        try {
          const qrCodeDataURL = await QRCode.toDataURL(qrText, { width: 80 });
          doc.addImage(qrCodeDataURL, 'PNG', 10, y, 14, 14);
        } catch (e) { /* ignore */ }
        doc.setFontSize(7).setFont('helvetica', 'normal');
        doc.text(`Prepared By: ${Name}`, 28, y + 8);
        doc.text('Authorized Signature', pageWidth - 50, y + 8);
    
        return y + 16;
      };
    
      // ============================================
      // PAGE 1: With Header → 2 copies stacked; Without → 1 copy
      // ============================================
      let headerImageBase64 = null;
      if (headerOption === 'with') {
        try { headerImageBase64 = await imageUrlToBase64(image); } catch (_) {}
      }
    
     
        if (headerOption === 'with') {
          if (printLayout === 'separate') {
              // ── SEPARATE PAGES: only the Patient Copy on a single A4 page ──
              await drawSingleReceipt(0, 'PATIENT COPY', headerImageBase64);
              // (Office Copy removed — separate layout now prints one page only)
          } else {
            // ── SAME PAGE: 2 copies stacked on one A4 page (existing behaviour) ──
            // Top half — Patient Copy
            await drawSingleReceipt(0, 'PATIENT COPY', headerImageBase64);
    
            // Cut line at the middle
            doc.setLineDashPattern([2, 2], 0);
            doc.setDrawColor(120, 120, 120);
            doc.line(8, HALF, pageWidth - 8, HALF);
            doc.setFontSize(6).setTextColor(120, 120, 120);
            doc.text('✂  Cut here', pageWidth / 2, HALF - 0.5, { align: 'center' });
            doc.setLineDashPattern([], 0);
            doc.setDrawColor(0, 0, 0);
            doc.setTextColor(0, 0, 0);
    
            // Bottom half — Office Copy
            await drawSingleReceipt(HALF + 2, 'OFFICE COPY', headerImageBase64);
        }
    } else {
        // Plain mode — single copy, no header, starting at top
        await drawSingleReceipt(0, '', null);
    }
    
      // ============================================
      // PAGE 2+: Lab Copy / Radiology Copies (unchanged behaviour)
      // ============================================
      const radiologyCategories = [
        { key: 'xray',         title: 'X-RAY COPY',            keywords: ['x-ray', 'xray', 'x ray'] },
        { key: 'ct',           title: 'CT SCAN COPY',          keywords: ['ct scan', 'ct-scan', 'ctscan', 'ct '] },
        { key: 'mri',          title: 'MRI COPY',              keywords: ['mri'] },
        { key: 'usg',          title: 'ULTRASOUND / USG COPY', keywords: ['ultrasound', 'usg', 'sonography', 'sono'] },
        { key: 'ecg',          title: 'ECG COPY',              keywords: ['ecg', 'electrocardiogram'] },
        { key: 'echo',         title: 'ECHO COPY',             keywords: ['echo', 'echocardiography', 'echocardiogram'] },
        { key: 'eeg',          title: 'EEG COPY',              keywords: ['eeg', 'electroencephalogram'] },
        { key: 'emg',          title: 'EMG COPY',              keywords: ['emg', 'electromyography'] },
        { key: 'mammography',  title: 'MAMMOGRAPHY COPY',      keywords: ['mammography', 'mammogram'] },
        { key: 'fluoroscopy',  title: 'FLUOROSCOPY COPY',      keywords: ['fluoroscopy'] },
        { key: 'dexa',         title: 'DEXA SCAN COPY',        keywords: ['dexa', 'bone density'] },
        { key: 'pet',          title: 'PET SCAN COPY',         keywords: ['pet scan', 'pet-scan'] },
      ];
    
      const isRadiologyTest = (n) => {
        const name = String(n || '').toLowerCase();
        return radiologyCategories.some(cat => cat.keywords.some(kw => name.includes(kw)));
      };
      const getRadiologyCategory = (n) => {
        const name = String(n || '').toLowerCase();
        for (const cat of radiologyCategories) {
          if (cat.keywords.some(kw => name.includes(kw))) return cat.key;
        }
        return null;
      };
    
      const allTests = formData.tests1 || [];
      const labTests = allTests.filter(t => !isRadiologyTest(t.test_name || t.lab_item_test_name || ''));
      const radiologyGroups = {};
      allTests.forEach(t => {
        const testName = t.test_name || t.lab_item_test_name || '';
        const catKey = getRadiologyCategory(testName);
        if (catKey) {
          if (!radiologyGroups[catKey]) radiologyGroups[catKey] = [];
          radiologyGroups[catKey].push(t);
        }
      });
    
      const drawCopyPage = async (title, tests) => {
        if (!tests || tests.length === 0) return;
        doc.addPage();
        let copyY = 0;
        if (headerImageBase64) {
          doc.addImage(headerImageBase64, 0, 0, pageWidth, 26);
          copyY = 29;
        } else {
          copyY = 6;
        }
        doc.setFontSize(12).setFont('helvetica', 'bold');
        doc.text(title, pageWidth / 2, copyY + 4, { align: 'center' });
        copyY += 10;
        copyY = drawPatientDetails(copyY) + 1;
    
        const tableData = tests.map((t, i) => [i + 1, t.test_name || t.lab_item_test_name || 'N/A']);
        autoTable(doc, {
          startY: copyY,
          head: [['Sl. No', 'Test Name']],
          body: tableData,
          theme: 'grid',
          headStyles: { fillColor: [240,240,240], textColor: 0, fontStyle: 'bold', fontSize: 9 },
          bodyStyles: { fontSize: 9, textColor: 0 },
          styles: { cellPadding: 3, lineWidth: 0.1, lineColor: [0,0,0] },
          margin: { left: 10, right: 10 },
          columnStyles: { 0: { cellWidth: 25, halign: 'center' }, 1: { cellWidth: 165 } }
        });
        copyY = doc.lastAutoTable.finalY + 10;
        doc.setFontSize(8).setFont('helvetica', 'normal');
        doc.text(`Prepared By: ${Name}`, 10, copyY + 10);
        doc.text('Authorized Signature', 160, copyY + 10);
      };
    
      if (headerOption === 'with') {
        if (includeLabCopy && labTests.length > 0) {
          await drawCopyPage('LAB COPY', labTests);
        }
        if (includeRadiologyCopy) {
          for (const cat of radiologyCategories) {
            const tests = radiologyGroups[cat.key];
            if (tests && tests.length > 0) {
              await drawCopyPage(cat.title, tests);
            }
          }
        }
      }
    
      // ============================================
      // OPEN PDF
      // ============================================
      const pdfBlob = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const newWindow = window.open(pdfUrl, '_blank');
      newWindow.onload = function () {
        newWindow.print();
      };
    };



// Helper function to format date as DD-MM-YYYY
const formatDate = (dateString) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
  } catch (e) {
    return dateString;
  }
};
// returns a human-friendly age string or 'N/A' when all parts are zero/absent
const getAgeDisplay = (fd) => {
  if (!fd) return 'N/A';
  const y = Math.max(0, Number(fd.lab_reg_age_year || 0) || 0);
  const m = Math.max(0, Number(fd.lab_reg_age_month || 0) || 0);
  const d = Math.max(0, Number(fd.lab_reg_age_day || 0) || 0);

  if (y === 0 && m === 0 && d === 0) return 'N/A';

  const parts = [];
  if (y > 0) parts.push(`${y} Yr${y > 1 ? 's' : ''}`);
  if (m > 0) parts.push(`${m} M${m > 1 ? '' : ''}`); // "M" for months
  if (d > 0) parts.push(`${d} D${d > 1 ? '' : ''}`); // "D" for days

  return parts.join(' ');
};

// Improved amount in words function
const amountInWords = (amount) => {
  const num = parseFloat(amount);
  if (isNaN(num) || num === 0) return 'Zero';
  
  const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  
  const convertLessThanThousand = (n) => {
    if (n === 0) return '';
    let res = '';
    
    const hundreds = Math.floor(n / 100);
    if (hundreds > 0) {
      res += units[hundreds] + ' Hundred ';
      n %= 100;
    }
    
    if (n > 0) {
      if (res !== '') res += 'and ';
      
      if (n < 10) {
        res += units[n];
      } else if (n < 20) {
        res += teens[n - 10];
      } else {
        res += tens[Math.floor(n / 10)];
        if (n % 10 > 0) {
          res += ' ' + units[n % 10];
        }
      }
    }
    
    return res.trim();
  };
  
  if (num === 0) return 'Zero';
  
  let result = '';
  let n = num;
  
  // Crores
  const crores = Math.floor(n / 10000000);
  if (crores > 0) {
    result += convertLessThanThousand(crores) + ' Crore ';
    n %= 10000000;
  }
  
  // Lakhs
  const lakhs = Math.floor(n / 100000);
  if (lakhs > 0) {
    result += convertLessThanThousand(lakhs) + ' Lakh ';
    n %= 100000;
  }
  
  // Thousands
  const thousands = Math.floor(n / 1000);
  if (thousands > 0) {
    result += convertLessThanThousand(thousands) + ' Thousand ';
    n %= 1000;
  }
  
  // Hundreds
  result += convertLessThanThousand(n);
  
  return result.trim();
};


  

    // console.log("this is test1 : " +  JSON.stringify(formData.tests1))


    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">

                        <h2 style={{color:"#405189"}}>Lab Registration</h2>
                        <br />
                        {formData.lab_reg_uhid && (
  <div className="alert alert-info alert-dismissible fade show" role="alert">
    <i className="ri-information-line me-2"></i>
    <strong>Patient data loaded</strong> - UHID: {formData.lab_reg_uhid}
    {formData.lab_remarks && formData.lab_remarks.includes('IPD') && (
      <span className="ms-2 badge bg-primary">From IPD</span>

      
    )}
    <button type="button" className="btn-close" onClick={() => {
      setFormData(prev => ({ ...prev, lab_reg_uhid: "", lab_remarks: "" }));
      setIsUHIDReadOnly(false);
    }}></button>
  </div>
)}
                        <div class="live-preview">
                            <form onSubmit={handleSubmit} noValidate>
                            <div className="card">
    <div className="card-body">
        <div className="row">

            {/* ── Header ── */}
            <div className="col-lg-12">
                <h5 style={{color:"#405189"}}>Patient Details</h5>
                <br />
            </div>

            {/* ── ROW 1: Registration Type + Search ── */}
            <div className="col-md-2">
                <div className="mb-3">
                    <label className="form-label">Registration Type</label>
                    <select className="form-control" name="lab_reg_type"
                        onChange={handleChange} value={formData.lab_reg_type} required>
                        <option value="Direct">Direct</option>
                        <option value="OPD">OPD</option>
                        <option value="IPD">IPD</option>
                    </select>
                </div>
            </div>

            <div className="col-md-4">
    <div className="mb-3" style={{position:'relative'}}>
        <label className="form-label">
            Search Patient
            <small className="text-muted ms-2" style={{fontSize:11, fontWeight:400}}>
                (UHID / Phone / Name)
            </small>
        </label>

        <div className="input-group">
            <span className="input-group-text" style={{background:'#f8f9fa'}}>
                <i className="ri-search-line text-primary"/>
            </span>
            <input
                type="text"
                className="form-control"
                placeholder="Type UHID, 10-digit phone, or patient name..."
                value={labSearchInput}
                onChange={e => handleLabUnifiedSearch(e.target.value)}
                autoComplete="off"
                disabled={isUHIDReadOnly}
                style={{backgroundColor: isUHIDReadOnly ? '#e9ecef' : 'white'}}
            />
            {searchLoading && (
                <span className="input-group-text" style={{background:'#fff'}}>
                    <span className="spinner-border spinner-border-sm text-primary"/>
                </span>
            )}
            {labSearchInput && !isUHIDReadOnly && (
                <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => { setLabSearchInput(''); setLabSearchSuggestions([]); }}
                    title="Clear">
                    <i className="ri-close-line"/>
                </button>
            )}
        </div>

        <small className="text-muted" style={{fontSize:10}}>
            💡 Phone (10 digits) searches instantly. UHID/Name needs 3+ characters.
        </small>

        {/* Unified suggestions dropdown */}
        {labSearchSuggestions.length > 0 && (
            <ul style={{
                position:'absolute',
                top:'100%',
                left:0,
                right:0,
                zIndex:1050,
                maxHeight:280,
                overflowY:'auto',
                border:'1px solid #dee2e6',
                borderRadius:4,
                boxShadow:'0 4px 12px rgba(0,0,0,0.15)',
                margin:'4px 0 0 0',
                padding:0,
                listStyle:'none',
                background:'#fff'
            }}>
                <li style={{
                    padding:'6px 12px',
                    background:'#f8f9fa',
                    borderBottom:'1px solid #dee2e6',
                    fontSize:11,
                    color:'#405189',
                    fontWeight:600
                }}>
                    {labSearchSuggestions.length} match{labSearchSuggestions.length !== 1 ? 'es' : ''} found — click to select
                </li>
                {labSearchSuggestions.map((user, idx) => (
                    <li key={idx}
                        onClick={() => applyPatientToForm(user)}
                        style={{
                            cursor:'pointer',
                            fontSize:12,
                            padding:'10px 12px',
                            borderBottom:'1px solid #f0f0f0',
                            transition:'background .1s'
                        }}
                        onMouseEnter={e => e.currentTarget.style.background='#f0f4ff'}
                        onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                        <div className="d-flex justify-content-between align-items-start">
                            <div style={{flex:1}}>
                                <div>
                                    <strong style={{color:'#405189'}}>{user.lab_reg_name_title} {user.lab_reg_name}</strong>
                                </div>
                                <div className="text-muted mt-1" style={{fontSize:11}}>
                                    <span className="me-2">
                                        <i className="ri-fingerprint-line me-1"/>
                                        <strong>{user.lab_reg_uhid}</strong>
                                    </span>
                                    <span className="me-2">
                                        <i className="ri-phone-line me-1"/>
                                        {user.lab_reg_mobile}
                                    </span>
                                    <span className="me-2">
                                        {user.lab_reg_age_year ? user.lab_reg_age_year+'Y' : ''} / {user.lab_reg_gender}
                                    </span>
                                </div>
                            </div>
                            <div className="d-flex gap-1 ms-2 flex-shrink-0 flex-wrap" style={{maxWidth:120}}>
                                {(user.lab_visit_count > 0) && (
                                    <span className="badge" style={{background:'#cff4fc',color:'#055160',fontSize:9}}>
                                        🧪{user.lab_visit_count}x
                                    </span>
                                )}
                                {(user.ipd_visit_count > 0) && (
                                    <span className="badge" style={{background:'#cfe2ff',color:'#084298',fontSize:9}}>
                                        🏥{user.ipd_visit_count}x
                                    </span>
                                )}
                                {(user.opd_visit_count > 0) && (
                                    <span className="badge" style={{background:'#d1e7dd',color:'#0f5132',fontSize:9}}>
                                        🩺{user.opd_visit_count}x
                                    </span>
                                )}
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        )}

    </div>
</div>

            {/* hidden legacy trigger */}
            <button id="pop45" style={{ display: "none" }} type="button"
                className="btn btn-success add-btn px-0"
                data-bs-toggle="modal" data-bs-target="#usrModel"/>

            {/* ── ROW 2: Age (left) + Patient Name (right) ── */}
            <div className="col-md-6">
                <div className="mb-3">
                    <label className="form-label">Age</label>
                    <div className="row mt-1">
                        <div className="col-md-4">
                            <input ref={ageYearRef} type="number" className="form-control"
                                placeholder="Year" name="lab_reg_age_year"
                                onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur}
                                value={formData.lab_reg_age_year} required/>
                        </div>
                        <div className="col-md-4">
                            <input type="number" className="form-control"
                                placeholder="Month" name="lab_reg_age_month"
                                onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur}
                                value={formData.lab_reg_age_month}/>
                        </div>
                        <div className="col-md-4">
                            <input type="number" className="form-control"
                                placeholder="Day" name="lab_reg_age_day"
                                onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur}
                                value={formData.lab_reg_age_day}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-6">
                <div className="mb-3">
                    <label className="form-label">Patient Name</label>
                    <div className="row">
                        <div className="col-md-3">
                            <select className="form-control" name="lab_reg_name_title"
                                onChange={handleAutoGenderChange}
                                value={formData.lab_reg_name_title} required>
                                <option value="Mr.">Mr.</option>
                                <option value="Mrs.">Mrs.</option>
                                <option value="Miss">Miss</option>
                                <option value="Master">Master</option>
                                <option value="B/O">B/O</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div className="col-md-6">
                            <input ref={patientNameRef} type="text" className="form-control"
                                placeholder="Enter Name" name="lab_reg_name"
                                onChange={handleChange} value={formData.lab_reg_name} required/>
                        </div>
                        <div className="col-md-3">
                            <select className="form-control" name="lab_reg_gender"
                                value={formData.lab_reg_gender}
                                onChange={e => setFormData(prev => ({...prev, lab_reg_gender: e.target.value}))}
                                required>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── ROW 3: Mobile + Guardian (left) | empty right ── */}
            <div className="col-md-6">
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Mobile Number</label>
                            <input type="text" className="form-control"
                                placeholder="Enter Mobile Number"
                                name="lab_reg_mobile"
                                onChange={handleChange}
                                value={formData.lab_reg_mobile} required/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Guardian</label>
                            <div className="row">
                                <div className="col-md-4">
                                    <select className="form-control"
                                        name="lab_guardian_title"
                                        onChange={handleChange}
                                        value={formData.lab_guardian_title}>
                                        <option value="C/O">C/O</option>
                                        <option value="S/O">S/O</option>
                                        <option value="D/O">D/O</option>
                                    </select>
                                </div>
                                <div className="col-md-8">
                                    <input type="text" className="form-control"
                                        placeholder="Enter Name"
                                        name="lab_guardian_name"
                                        onChange={handleChange}
                                        value={formData.lab_guardian_name}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* right spacer to keep alignment */}
           

            {/* ── ROW 4: Address (left) + City & State (right) ── */}
            <div className="col-md-6">
                <div className="mb-3">
                    <label className="form-label">Address</label>
                    <input type="text" className="form-control"
                        placeholder="Enter Address"
                        name="lab_reg_address"
                        onChange={handleChange}
                        value={formData.lab_reg_address}/>
                </div>
            </div>

            <div className="col-md-3">
                <div className="mb-3">
                    <label className="form-label">City</label>
                    <input type="text" className="form-control"
                        placeholder="Enter City"
                        name="lab_reg_city"
                        onChange={handleChange}
                        value={formData.lab_reg_city}/>
                </div>
            </div>

            <div className="col-md-3">
                <div className="mb-3">
                    <label className="form-label">State</label>
                    <input type="text" className="form-control"
                        placeholder="Enter State"
                        name="lab_reg_state"
                        onChange={handleChange}
                        value={formData.lab_reg_state}/>
                </div>
            </div>

            {/* ── ROW 5: Referral Doctor (left) + Referral Broker (right) ── */}
            <div className="col-md-6">
                <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between mb-1">
                        <label className="form-label mb-0">Referral Doctor</label>
                        <div>
                            <button id="addbt453" style={{display:"none"}} type="button"
                                className="btn btn-success add-btn"
                                data-bs-toggle="modal" data-bs-target="#showModal"/>
                            <button type="button" className="btn btn-success btn-sm"
                                onClick={e => {
                                    e.preventDefault();
                                    document.getElementById("addbt453").click();
                                }}>
                                <i className="ri-add-line me-1"/>Add Doctor
                            </button>
                        </div>
                    </div>
                    <Select
                        isClearable
                        placeholder="Search doctor by name"
                       options={doctorSource.map(d => ({
    value: String(d.user_id ?? d.id ?? ""),
    label: `${(d.fname||"").trim()}${d.lname?" "+(d.lname||"").trim():""}`.trim(),
    meta: {
        speciality: d.doc?.doc_specality || "",
        degree: d.doc?.doc_degree || ""
    },
    raw: d
}))}
                        onInputChange={(inputValue, { action }) => {
                            if (action === "input-change") {
                                setDocSearch(inputValue);
                                setFormData(prev => ({ ...prev, lab_reg_referral: inputValue }));
                                setReferralId("");
                            }
                        }}
                        value={(() => {
                           const opts = doctorSource.map(d => ({
        value: String(d.user_id ?? d.id ?? ""),
                                label: `${(d.fname||"").trim()}${d.lname?" "+(d.lname||"").trim():""}`.trim(),
                                raw: d
                            }));
                            if (referralId) {
                                const found = opts.find(o => o.value === String(referralId));
                                if (found) return found;
                                return { value: String(referralId), label: formData.lab_reg_referral || String(referralId) };
                            }
                            return null;
                        })()}
                        onChange={opt => {
                            if (!opt) {
                                setReferralId(""); setDocSearch("");
                                setFormData(prev => ({ ...prev, lab_reg_referral: "" }));
                                return;
                            }
                            setReferralId(opt.value);
                            setDocSearch(opt.label || "");
                            setFormData(prev => ({ ...prev, lab_reg_referral: opt.label || "" }));
                        }}
                        formatOptionLabel={(opt, { context }) =>
                            context === "menu"
                                ? <div><div style={{fontWeight:600}}>{opt.label}</div></div>
                                : <div>{opt.label}</div>
                        }
                        menuPortalTarget={document.body}
                        styles={{
                            control: p => ({...p, minHeight:'38px', borderRadius:4}),
                            menuPortal: b => ({...b, zIndex:9999}),
                            option: p => ({...p, padding:'8px 12px'})
                        }}
                        noOptionsMessage={() => "No doctor found"}
                        isSearchable
                        backspaceRemovesValue
                    />
                </div>
            </div>

            <div className="col-md-6">
    <div className="mb-3">
        <div className="d-flex align-items-center justify-content-between mb-1">
            <label className="form-label mb-0">Referral</label>
            <div>
                {/* ✅ Hidden trigger button for NewBroker modal */}
                <button 
                    id="addBrokerBtn" 
                    style={{display:"none"}} 
                    type="button"
                    className="btn btn-success add-btn"
                    onClick={() => setShowBrokerModal(true)}
                />
                <button 
                    type="button" 
                    className="btn btn-success btn-sm"
                    onClick={(e) => {
                        e.preventDefault();
                        setShowBrokerModal(true);
                    }}
                >
                    <i className="ri-add-line me-1"/>Add Referral
                </button>
            </div>
        </div>
        <Select
            isClearable
            placeholder="Search broker by name or phone..."
            options={brokerOptions}
            isLoading={loadingBrokers}
            onInputChange={(val, action) => {
                if (action === 'input-change') {
                    if (brokerDebounceRef.current) clearTimeout(brokerDebounceRef.current);
                    brokerDebounceRef.current = setTimeout(() => loadBrokers(val), 300);
                }
            }}
            onChange={opt => {
                if (!opt) { setBrokerId(''); setBrokerLabel(''); }
                else { setBrokerId(String(opt.value)); setBrokerLabel(opt.label || ''); }
            }}
            value={brokerId
                ? (brokerOptions.find(o => String(o.value) === String(brokerId)) ||
                   { value: String(brokerId), label: brokerLabel })
                : null}
            menuPortalTarget={document.body}
            styles={{ menuPortal: b => ({...b, zIndex:9999}) }}
            noOptionsMessage={() => loadingBrokers ? 'Loading...' : 'No Referral'}
        />
    </div>
</div>

            {/* hidden fields */}
            <div style={{display:'none'}}>
                <input type="text" className="form-control"
                    value={formData.lab_collected_at}
                    onChange={e => setFormData(prev=>({...prev, lab_collected_at: e.target.value}))}
                    onFocus={() => setShowCollectedDropdown(true)}
                    onBlur={() => setTimeout(()=>setShowCollectedDropdown(false), 200)}/>
                <input type="date" className="form-control"
                    name="lab_reg_date" onChange={handleChange}
                    value={formData.lab_reg_date} required readOnly/>
            </div>

        </div>{/* end .row */}
    </div>{/* end .card-body */}
</div>





                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <hr />
                                                <h5 style={{color:"#405189"}}>Select Tests</h5>
                                                <div class="card-body border border-dashed border-end-0 border-start-0">
                                                    <form>
                                                        <div class="row g-3">
                                                            <div class="col-xxl-2 col-sm-2"></div>
                                                   <div class="col-xxl-8 col-sm-8">
                                                   <div className="search-box" style={{ position: 'relative' }}>
  <div style={{ position: 'relative' }}>
    <input
      ref={inputRef}
      className="form-control search"
      placeholder="Search tests..."
      type="text"
      name="search_key"
      autoComplete="off"
      value={formData.search_key}
      onChange={(e) => {
        handleChange(e);
        setTestPage(0); // reset page on new search
      }}
      onFocus={() => {
        setShowSearchDropdown(true);
        if (!formData.search_key || formData.search_key.trim().length === 0) {
          fetchTests("");
        }
      }}
      onBlur={() => setTimeout(() => setShowSearchDropdown(false), 150)}
    />
    <i className="ri-search-line search-icon"></i>

    {showSearchDropdown && (
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          zIndex: 1000,
          background: "#fff",
          border: "1px solid #dee2e6",
          borderRadius: "4px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        {isLoading ? (
          <div className="text-center p-2">
            <span className="spinner-border spinner-border-sm me-2"/>
            Searching...
          </div>
        ) : searchResults.length === 0 ? (
          <div className="p-2 text-muted text-center">No tests found</div>
        ) : (() => {
          const totalPages = Math.ceil(searchResults.length / TESTS_PER_PAGE);
          const startIdx = testPage * TESTS_PER_PAGE;
          const pageItems = searchResults.slice(startIdx, startIdx + TESTS_PER_PAGE);

          return (
            <>
              {/* Results count header */}
              <div style={{
                padding: '6px 12px',
                background: '#f8f9fa',
                borderBottom: '1px solid #dee2e6',
                fontSize: 12,
                color: '#405189',
                fontWeight: 600,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <span>{searchResults.length} test{searchResults.length !== 1 ? 's' : ''} found</span>
                {totalPages > 1 && (
                  <span style={{color:'#6c757d', fontSize:11}}>
                    Page {testPage + 1} of {totalPages}
                  </span>
                )}
              </div>

              {/* Test items */}
              {pageItems.map((test, idx) => (
                <div
                  key={idx}
                  className="dropdown-item"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleSelTst(test);
                    setFormData(prev => ({ ...prev, search_key: "" }));
                    fetchTests("");
                    setTestPage(0);
                    setShowSearchDropdown(true);
                    setTimeout(() => inputRef.current?.focus(), 50);
                  }}
                  style={{
                    cursor: 'pointer',
                    padding: '8px 12px',
                    borderBottom: '1px solid #f0f0f0',
                    transition: 'background .1s'
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <strong style={{fontSize:13}}>{test.test_name}</strong>
                      <div className="text-muted" style={{fontSize:11}}>
                        {test.cat_name}
                      </div>
                    </div>
                    <span style={{
                      fontWeight: 600,
                      color: '#198754',
                      fontSize: 13,
                      whiteSpace: 'nowrap',
                      marginLeft: 8
                    }}>
                      ₹{test.test_price}
                    </span>
                  </div>
                </div>
              ))}

              {/* Pagination */}
              {totalPages > 1 && (
                <div style={{
                  padding: '6px 10px',
                  background: '#f8f9fa',
                  borderTop: '1px solid #dee2e6',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    disabled={testPage === 0}
                    onMouseDown={e => {
                      e.preventDefault();
                      setTestPage(p => Math.max(0, p - 1));
                    }}
                    style={{minWidth: 70, fontSize: 12}}>
                    <i className="ri-arrow-left-s-line"/> Prev
                  </button>

                  <span style={{fontSize: 11, color: '#6c757d'}}>
                    {startIdx + 1}–{Math.min(startIdx + TESTS_PER_PAGE, searchResults.length)} of {searchResults.length}
                  </span>

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    disabled={testPage >= totalPages - 1}
                    onMouseDown={e => {
                      e.preventDefault();
                      setTestPage(p => Math.min(totalPages - 1, p + 1));
                    }}
                    style={{minWidth: 70, fontSize: 12}}>
                    Next <i className="ri-arrow-right-s-line"/>
                  </button>
                </div>
              )}
            </>
          );
        })()}
      </div>
    )}
  </div>
</div>

            </div>
                                                            {/* <div class="col-xxl-2 col-sm-2">
                                                                <button id="poptst45" type="button" class="btn btn-success add-btn" data-bs-toggle="modal" data-bs-target="#tstrtModal" fdprocessedid="jys8hw">
                                                                    <i class="ri-add-line align-bottom me-1"></i> Add </button>
                                                            </div> */}
                                                        </div>

                                                        {/* ── PATIENT SELECTION MODAL ── */}
{showPatientModal && (
    <div className="modal fade show d-block" tabIndex="-1"
        style={{backgroundColor:'rgba(0,0,0,0.5)', zIndex:10000}}>
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
                <div className="modal-header bg-primary text-white">
                    <h5 className="modal-title">
                        <i className="ri-group-line me-2"/>
                        Select Patient — {patientResults.length} found
                    </h5>
                    <button type="button" className="btn-close btn-close-white"
                        onClick={() => setShowPatientModal(false)}/>
                </div>
                <div className="modal-body p-2">
                    {patientResults.map((p, idx) => {
                        const age = [
                            p.lab_reg_age_year  ? `${p.lab_reg_age_year}Y`  : '',
                            p.lab_reg_age_month ? `${p.lab_reg_age_month}M` : '',
                            p.lab_reg_age_day   ? `${p.lab_reg_age_day}D`   : '',
                        ].filter(Boolean).join(' ') || 'N/A';
                        const labV   = p.lab_visit_count   ?? 0;
                        const ipdV   = p.ipd_visit_count   ?? 0;
                        const opdV   = p.opd_visit_count   ?? 0;
                        const pharmaV = p.pharma_visit_count ?? 0;
                        return (
                            <div key={idx} className="p-3 mb-2 rounded"
                                style={{border:'1px solid #dee2e6', cursor:'pointer',
                                    transition:'background .15s'}}
                                onMouseEnter={e => e.currentTarget.style.background='#f0f4ff'}
                                onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                                <div className="d-flex justify-content-between align-items-start">
                                    <div style={{flex:1}}>
                                        <div className="fw-bold fs-6">
                                            {p.lab_reg_name_title} {p.lab_reg_name}
                                        </div>
                                        <div className="text-muted mt-1" style={{fontSize:12}}>
                                            <span className="me-3">
                                                <i className="ri-fingerprint-line me-1"/>
                                                UHID: <strong>{p.lab_reg_uhid}</strong>
                                            </span>
                                            <span className="me-3">
                                                <i className="ri-user-line me-1"/>
                                                {age} / {p.lab_reg_gender}
                                            </span>
                                            <span>
                                                <i className="ri-phone-line me-1"/>
                                                {p.lab_reg_mobile}
                                            </span>
                                        </div>
                                        {/* Visit count badges */}
                                        <div className="mt-2 d-flex gap-2 flex-wrap">
                                            {labV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#cff4fc', color:'#055160',
                                                        fontSize:11, padding:'4px 8px'}}>
                                                    🧪 Lab: {labV}x
                                                </span>
                                            )}
                                            {ipdV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#cfe2ff', color:'#084298',
                                                        fontSize:11, padding:'4px 8px'}}>
                                                    🏥 IPD: {ipdV}x
                                                </span>
                                            )}
                                            {opdV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#d1e7dd', color:'#0f5132',
                                                        fontSize:11, padding:'4px 8px'}}>
                                                    🩺 OPD: {opdV}x
                                                </span>
                                            )}
                                            {pharmaV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#fff3cd', color:'#664d03',
                                                        fontSize:11, padding:'4px 8px'}}>
                                                    💊 Pharma: {pharmaV}x
                                                </span>
                                            )}
                                            {(labV+ipdV+opdV+pharmaV) === 0 && (
                                                <span className="badge bg-secondary"
                                                    style={{fontSize:11}}>
                                                    New Patient
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <button type="button"
                                        className="btn btn-sm btn-primary ms-3"
                                        onClick={() => applyPatientToForm(p)}>
                                        <i className="ri-check-line me-1"/>Select
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary"
                        onClick={() => setShowPatientModal(false)}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
)}
                                                    </form>
                                                </div>
                                                <br />
                                                <div class="card-body pt-0">
                                                    <div>

                                                        <div class="table-responsive table-card mb-1">
                                                            <table class="table table-nowrap align-middle" id="orderTable">
                                                                <thead class="text-muted table-light" style={{backgroundColor: "#17203b !important"}}>
                                                                    <tr class="text-uppercase">

                                                                        <th style={{ width: "60px"}} data-sort="id">S. No.</th>
                                                                        <th data-sort="customer_name">Test Name</th>
                                                                        <th data-sort="product_name">Price</th>
                                                                        <th data-sort="product_name">Discount</th>
                                                                        <th data-sort="city">Total</th>
                                                                        <th style={{ width: "120px" }} data-sort="city">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="list form-check-all">
                                                 {formData.tests1.map((item, index) => (
                                                  
  <tr key={index}>
    <td className="customer_name" data-type={item.id}>{index + 1}.</td>
    <td className="product_name">
  { item.test_name ?? item.lab_item_test_name ?? item._raw?.lab_item_test_name ?? 'N/A' }
</td>
<td className="date">
  { (Number(item.lab_item_total ?? item.test_price ?? item._raw?.lab_item_test_price ?? 0)).toFixed(2) }
</td>


 <td className="date">
  <input
    type="number"
    className="form-control"
    min="0"
    name="test_discount"
    value={item.test_discount ?? 0}   // yahan change
    onChange={(e) => {
      const value = parseFloat(e.target.value);
      const updatedTests = [...formData.tests1];

      // Update discount
      updatedTests[index].test_discount = value;

      // Calculate per test final price & save in lab_item_total
      const price = parseFloat(updatedTests[index].test_price || 0);
      updatedTests[index].lab_item_total = Math.max(price - value, 0);

      // Calculate grand total
      const ttl = updatedTests.reduce((sum, test) => {
        const p = parseFloat(test.test_price || 0);
        const d = parseFloat(test.test_discount || 0);
        return sum + Math.max(p - d, 0);
      }, 0);

      // Update state
      setFormData(prev => ({
        ...prev,
        tests1: updatedTests,
        lab_total: ttl.toFixed(2)
      }));
    }}
  />
</td>


    <td className="date">
      {/* Calculate and show final price for this test */}
      {parseFloat(item.lab_item_total || item.test_price).toFixed(2)}
    </td>

    <td>
      <ul className="list-inline hstack gap-2 mb-0">
        <li className="list-inline-item">
          <a
            href="#!"
            className="text-danger d-inline-block remove-item-btn"
            onClick={(e) => {
              e.preventDefault();
              const updatedTests = [...formData.tests1];
              updatedTests.splice(index, 1);

              // Recalculate total after removal
              const ttl = updatedTests.reduce((sum, test) => {
                const price = parseFloat(test.test_price || 0);
                const discount = parseFloat(test.test_discount || 0);
                return sum + Math.max(price - discount, 0);
              }, 0);

              setFormData(prev => ({
                ...prev,
                tests1: updatedTests,
                lab_total: ttl.toFixed(2)
              }));
            }}
          >
            <i className="ri-delete-bin-5-fill fs-16"></i>
          </a>
        </li>
      </ul>
    </td>
  </tr>
))}


                                                                </tbody>
                                                            </table>

                                                        </div>

                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
    <div class="card-body">
        <div class="row">

{/* Payment History Card - Only show if saved */}
{isSaved && formData.lab_reg_id && (
    <div className="card">
        <div className="card-body">
            <div className="row">
                <div className="col-lg-12">
                    <h5 style={{color:"#405189"}}>Payment History</h5>
                    <br />
                </div>
                <div className="col-lg-12">
                    {paymentHistory.length === 0 ? (
                        <div className="alert alert-info">No payment transactions yet</div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                                <thead className="table-light">
                                    <tr>
                                        <th style={{width: "60px"}}>Sl. No</th>
                                        <th>Date & Time</th>
                                        <th>Payment Mode</th>
                                        <th>Amount</th>
                                        <th>Received By</th>
                                        <th>Remarks</th>
                                        
                                            <th style={{width: "100px"}}>Action</th>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                    {paymentHistory.map((payment, index) => (
                                        <tr key={payment.payment_id}>
                                            <td>{index + 1}</td>
                                            <td>{new Date(payment.payment_datetime).toLocaleString()}</td>
                                            <td>
                                                <span className={`badge ${
                                                    payment.payment_mode === 'Cash' ? 'bg-success' :
                                                    payment.payment_mode === 'Card' ? 'bg-primary' :
                                                    'bg-info'
                                                }`}>
                                                    {payment.payment_mode}
                                                </span>
                                            </td>
                                            <td className="fw-bold">₹{parseFloat(payment.payment_amount).toFixed(2)}</td>
                                            <td>{payment.payment_received_by}</td>
                                            <td>{payment.payment_remarks || '-'}</td>
                                            
                                           <td>
  {(isAdmin || ldata?.role_id == 1 || ldata?.role_id === '1') && (
    <button
      className="btn btn-sm btn-danger"
      onClick={() => handleDeletePayment(payment.payment_id)}
    >
      Delete
    </button>
  )}
</td>
                                                    
                                               
                                            
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot className="table-light">
                                    <tr>
                                        <th colSpan="3" className="text-end">Total Paid:</th>
                                        <th className="fw-bold">
                                            ₹{paymentHistory.reduce((sum, p) => sum + parseFloat(p.payment_amount), 0).toFixed(2)}
                                        </th>
                                        <th colSpan={ldata?.type === 'admin' ? "3" : "2"}></th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>
)}

          
            <div class="col-lg-12">
                <h5 style={{color:"#405189"}}>Payment Details</h5>
                <br />
            </div>
            <div class="col-md-3">
                <div class="mb-3">
                    <label for="firstNameinput" class="form-label">Total Amount</label>
                    <input type="number" class="form-control" placeholder="Enter Total Amount"
                        name="lab_total" onChange={handleChange} value={formData.lab_total} required readOnly />
                </div>
            </div>
            <div class="col-md-3">
                <div class="mb-3">
                    <label for="firstNameinput" class="form-label">Discount(%)</label>
                    <input type="number" class="form-control" placeholder="Enter Discount"
                        name="lab_dis_per" onChange={handleChange} value={formData.lab_dis_per} onFocus={handleFocus}
                        onBlur={handleBlur} required />
                </div>
            </div>
            <div class="col-md-3">
                <div class="mb-3">
                    <label for="firstNameinput" class="form-label">Fixed Discount</label>
                    <input type="number" class="form-control" placeholder="Enter Fixed Deposit"
                        name="lab_fix_deposit" onChange={handleChange} value={formData.lab_fix_deposit} onFocus={handleFocus}
                        onBlur={handleBlur} required />
                </div>
            </div>
            <div class="col-md-3">
                <div class="mb-3">
                    <label for="firstNameinput" class="form-label">Final Amount</label>
                    <input type="number" class="form-control" placeholder="Enter Final Amount"
                        name="lab_final_amt" onChange={handleChange} value={formData.lab_final_amt} required readOnly />
                </div>
            </div>
            <div class="col-md-4">
                <div class="mb-3">
                    <label for="firstNameinput" class="form-label">Paid</label>
                    <input type="number" class="form-control" placeholder="Enter Paid"
                        name="lab_paid" onChange={handleChange} value={formData.lab_paid} readOnly 
                        style={{backgroundColor: '#e9ecef'}} />
                </div>
            </div>
            <div class="col-md-4">
                <div class="mb-3">
                    <label for="firstNameinput" class="form-label">Due</label>
                    <div className="input-group">
                        <input type="text" class="form-control" placeholder="Enter Due"
                            name="lab_due" onChange={handleChange} value={formData.lab_due} required readOnly 
                            style={{backgroundColor: '#e9ecef'}} />
                       {isSaved && parseFloat(formData.lab_due || 0) > 0 && (
    <button 
        className="btn btn-success" 
        type="button"
        onClick={() => {
            // ✅ Auto-fill with due amount
            const dueAmount = parseFloat(String(formData.lab_due).replace(/[,]/g, '')) || 0;
            setPaymentAmount(dueAmount.toFixed(2));
            setPaymentMode('Cash');
            setPaymentRemarks('');
            setShowPaymentModal(true);
        }}
    >
        <i className="ri-money-dollar-circle-line me-1"></i>
        Pay
    </button>
)}
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <div class="mb-3">
                    <label for="firstNameinput" class="form-label">Initial Pay Mode</label>
                    <select class="form-control" name="lab_pay_mode"
                        onChange={handleChange} value={formData.lab_pay_mode} required>
                        <option value="Cash">Cash</option>
                        <option value="Online">Online</option>
                        <option value="Card">Card</option>
                    </select>
                </div>
            </div>
            <div class="col-md-12">
                <div class="mb-3">
                    <label for="firstNameinput" class="form-label">Remarks</label>
                    <textarea class="form-control" placeholder="Enter Remarks"
                        name="lab_remarks" onChange={handleChange} value={formData.lab_remarks}></textarea>
                </div>
            </div>
            
            {/* Action Buttons */}
            <div class="col-lg-12">
                <div class="text-end">
                    {formData.lab_reg_id.length > 0 ? 
                        <button type="submit" class="btn btn-primary">Update</button> : 
                        <button type="submit" class="btn btn-primary">Save</button>
                    }
                    &nbsp;&nbsp;&nbsp;
                    <button
                        type="button"
                        className="btn btn-info"
                        disabled={!isSaved || !formData.lab_reg_uhid}
                        onClick={() => printThermalBarcodeIframe(formData.lab_reg_name, formData.lab_reg_age_year, formData.lab_reg_uhid)}
                    >
                        Print Barcode
                    </button>
                    <canvas ref={barcodeCanvasRef} style={{ display: 'none' }} />
                    &nbsp;&nbsp;&nbsp;
                    <button
    type="button"
    className="btn btn-dark"
    onClick={(e) => {
        e.preventDefault();
        setShowModal(true);
    }}
    disabled={!isSaved}
>
    Print Receipt
</button>
                    &nbsp;&nbsp;&nbsp;
                    <button
    type="button"
    className="btn btn-danger"
    onClick={() => navigate("/lab_patient_list")}
    
  >
    Close
  </button>
                </div>
            </div>
        </div>
    </div>
</div>



{/* Payment Modal */}
{showPaymentModal && (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Add Payment</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowPaymentModal(false)}
                    ></button>
                </div>
                <div className="modal-body">
                    <div className="mb-3">
                        <label className="form-label">Due Amount</label>
                        <input
                            type="text"
                            className="form-control"
                            value={`₹${parseFloat(formData.lab_due || 0).toFixed(2)}`}
                            readOnly
                            style={{backgroundColor: '#e9ecef', fontWeight: 'bold', fontSize: '1.1rem'}}
                        />
                    </div>
                    
                    <div className="mb-3">
                        <label className="form-label">Payment Mode *</label>
                        <select
                            className="form-control"
                            value={paymentMode}
                            onChange={(e) => setPaymentMode(e.target.value)}
                        >
                            <option value="Cash">Cash</option>
                            <option value="Card">Card</option>
                            <option value="Online">Online</option>
                        </select>
                    </div>
                    
                    <div className="mb-3">
    <label className="form-label">Payment Amount *</label>
    <input
        type="number"
        className="form-control"
        placeholder="Enter amount"
        value={paymentAmount}
        onChange={(e) => setPaymentAmount(e.target.value)}
        max={parseFloat(String(formData.lab_due).replace(/[,]/g, ''))}
        step="0.01"
        min="0.01"
    />
    <small className="text-muted">
        Maximum: ₹{parseFloat(String(formData.lab_due).replace(/[,]/g, '') || 0).toFixed(2)}
    </small>
    {/* ✅ Quick buttons */}
    <div className="mt-2 d-flex gap-2">
        <button 
            type="button" 
            className="btn btn-sm btn-outline-primary"
            onClick={() => setPaymentAmount((parseFloat(String(formData.lab_due).replace(/[,]/g, '')) || 0).toFixed(2))}
        >
            Full Amount
        </button>
        <button 
            type="button" 
            className="btn btn-sm btn-outline-secondary"
            onClick={() => setPaymentAmount((parseFloat(String(formData.lab_due).replace(/[,]/g, '')) / 2 || 0).toFixed(2))}
        >
            Half Amount
        </button>
    </div>
</div>
                    
                    <div className="mb-3">
                        <label className="form-label">Received By *</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter name"
                            value={paymentReceivedBy}
                            onChange={(e) => setPaymentReceivedBy(e.target.value)}
                            readOnly
                        />
                    </div>
                    
                    <div className="mb-3">
                        <label className="form-label">Remarks</label>
                        <textarea
                            className="form-control"
                            rows="2"
                            placeholder="Optional remarks"
                            value={paymentRemarks}
                            onChange={(e) => setPaymentRemarks(e.target.value)}
                        ></textarea>
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowPaymentModal(false)}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleAddPayment}
                    >
                        <i className="ri-check-line me-1"></i>
                        Add Payment
                    </button>
                </div>
            </div>
        </div>
    </div>
)}


                            </form>

                            {showModal && (
                            <div
                                className="modal fade show d-block"
                                tabIndex="-1"
                                style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}
                                onClick={(e) => {
                                    // Close modal if clicked outside
                                    if (e.target === e.currentTarget) {
                                        setShowModal(false);
                                    }
                                }}
                            >
                                <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Print Receipt</h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() => setShowModal(false)}
                                                aria-label="Close"
                                            ></button>
                                        </div>

                                        <div className="modal-body">
    <p className="mb-3">Choose header option for your receipt:</p>
    
    <div className="form-check mb-2">
        <input
            className="form-check-input"
            type="radio"
            name="headerOption"
            id="withHeader"
            value="with"
            defaultChecked
        />
        <label className="form-check-label" htmlFor="withHeader">
            <strong>With Header</strong>
            <div className="text-muted small">Include hospital logo, header + Lab Copy + Radiology Copy</div>
        </label>
    </div>

    <div className="form-check mb-3">
        <input
            className="form-check-input"
            type="radio"
            name="headerOption"
            id="withoutHeader"
            value="without"
        />
        <label className="form-check-label" htmlFor="withoutHeader">
            <strong>Without Header</strong>
            <div className="text-muted small">Plain receipt only (no Lab/Radiology copy pages)</div>
        </label>
    </div>

    <hr />
    <p className="mb-2 fw-bold">Copy Pages (only with "With Header"):</p>
    
    <div className="form-check mb-2">
        <input
            className="form-check-input"
            type="checkbox"
            name="includeLabCopy"
            id="includeLabCopy"
            //defaultChecked
        />
        <label className="form-check-label" htmlFor="includeLabCopy">
            Lab Copy
        </label>
    </div>

    <div className="form-check mb-2">
        <input
            className="form-check-input"
            type="checkbox"
            name="includeRadiologyCopy"
            id="includeRadiologyCopy"
            //defaultChecked
        />
        <label className="form-check-label" htmlFor="includeRadiologyCopy">
            Radiology Copy
        </label>
    </div>
    <hr />
<p className="mb-2 fw-bold">Print Layout (only with "With Header"):</p>



<div className="form-check mb-3">
    <input
        className="form-check-input"
        type="radio"
        name="printLayout"
        id="layoutSeparate"
        value="separate"
        defaultChecked
    />
    <label className="form-check-label" htmlFor="layoutSeparate">
        <strong>Separate Pages</strong>
        <div className="text-muted small">Patient Copy on page 1, Office Copy on page 2</div>
    </label>
</div>


<div className="form-check mb-2">
    <input
        className="form-check-input"
        type="radio"
        name="printLayout"
        id="layoutSame"
        value="same"
        
    />
    <label className="form-check-label" htmlFor="layoutSame">
        <strong>Same Page</strong>
        <div className="text-muted small">Patient Copy + Office Copy on one A4 page (cut in middle)</div>
    </label>
</div>


</div>




                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={() => setShowModal(false)}
                                            >
                                                <i className="ri-close-line me-1"></i>
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  const selectedOption = document.querySelector('input[name="headerOption"]:checked');
                                                  if (selectedOption) {
                                                      const headerOption = selectedOption.value;
                                                      const includeLabCopy = document.getElementById('includeLabCopy')?.checked || false;
                                                      const includeRadiologyCopy = document.getElementById('includeRadiologyCopy')?.checked || false;
                                                      // NEW: read print layout choice (default to 'same' if not found)
                                                      const layoutEl = document.querySelector('input[name="printLayout"]:checked');
                                                      const printLayout = layoutEl ? layoutEl.value : 'same';
                                                      
                                                      console.log("Header:", headerOption, "Layout:", printLayout, "Lab:", includeLabCopy, "Radiology:", includeRadiologyCopy);
                                                      generatePDF(headerOption, includeLabCopy, includeRadiologyCopy, printLayout);
                                                      setShowModal(false);
                                                  } else {
                                                      toast.error("Please select a header option");
                                                  }
                                              }}
                                            >
                                                <i className="ri-printer-line me-1"></i>
                                                Proceed to Print
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        </div>
                    </div>

                </div>
            </div>

            
            <AddDoctor  onAddDepart={handleAddDepart}/>


            {/* NewBroker Modal */}
<NewBroker
    item={null}
    show={showBrokerModal}
    onClose={(refresh) => {
        setShowBrokerModal(false);
        if (refresh) {
            // Reload brokers list after adding new broker
            loadBrokers('');
        }
    }}
/>
        </div>
    );
}

export default Registrations;
